{
  "app": {
    "title": "Pipeup - o CRM inteligente"
  },
  "common": {
    "save": "Salvar",
    "cancel": "Cancelar",
    "loading": "Carregando...",
    "cnpjLabel": "CNPJ",
    "countries": {
      "br": "BR (+55)",
      "nl": "NL (+31)",
      "pt": "PT (+351)",
      "es": "ES (+34)",
      "de": "DE (+49)",
      "fr": "FR (+33)",
      "uk": "UK (+44)",
      "be": "BE (+32)",
      "it": "IT (+39)"
    }
  },
  "auth": {
    "carousel": {
      "logoAlt": "Pipeup Logo",
      "crmLabel": "PIPEUP CRM",
      "slide1Title": "Transforme seu processo de vendas em resultados previsíveis",
      "slide1Subtitle": "Gerencie pipeline, atividades e negociações em um só lugar.",
      "slide2Title": "Pare de perder oportunidades por desorganização",
      "slide2Subtitle": "Centralize leads, contatos e negociações no pipeup.",
      "slide3Title": "Controle total do seu pipeline comercial",
      "slide3Subtitle": "Veja em que etapa cada negócio está — sem esforço.",
      "slide4Title": "Mais foco no time, menos trabalho manual",
      "slide4Subtitle": "Automatize tarefas e acompanhe tudo em tempo real.",
      "slide5Title": "Decisões melhores",
      "slide5TitleLine2": "com dados claros",
      "slide5Subtitle": "Métricas, desempenho e previsões sempre visíveis.",
      "goToMessage": "Ir para mensagem {{n}}",
      "messageN": "Mensagem {{n}}"
    }
  },
  "forgotPassword": {
    "title": "recuperar acesso",
    "subtitle": "informe seu email para receber um código de verificação",
    "email": "email",
    "emailPlaceholder": "seu@email.com",
    "submit": "enviar código",
    "submitting": "enviando...",
    "backToLogin": "Voltar para login"
  },
  "signup": {
    "title": "crie sua conta",
    "subtitle": "comece sua jornada com o pipeup",
    "companyName": "nome da empresa",
    "companyNamePlaceholder": "Minha Empresa Ltda",
    "cnpj": "CNPJ",
    "cnpjPlaceholder": "00.000.000/0000-00",
    "kvk": "KVK",
    "kvkPlaceholder": "12345678",
    "cnpjRequired": "CNPJ é obrigatório",
    "cnpjDigits": "CNPJ deve ter 14 dígitos",
    "cnpjInvalid": "CNPJ inválido",
    "kvkRequired": "KVK é obrigatório",
    "kvkDigits": "KVK deve ter 8 dígitos",
    "kvkInvalid": "KVK inválido",
    "phone": "telefone / whatsapp",
    "phonePlaceholder": "(11) 99999-8888",
    "phoneCountry": "País",
    "phoneRequired": "Telefone é obrigatório",
    "phoneInvalidLength": "O número deve ter entre {{min}} e {{max}} dígitos",
    "userName": "seu nome",
    "userNamePlaceholder": "João Silva",
    "email": "email",
    "emailPlaceholder": "seu@email.com",
    "password": "senha",
    "passwordPlaceholder": "••••••••",
    "confirmPassword": "confirmar senha",
    "confirmPasswordPlaceholder": "Repita sua senha",
    "submit": "criar conta",
    "submitting": "criando conta...",
    "hasAccount": "Já tem uma conta?",
    "doLogin": "Fazer login",
    "footer": "Ao continuar, você concorda com nossos Termos de Serviço e Política de Privacidade."
  },
  "planSelection": {
    "leftTitle": "Escolha o plano ideal para o seu time crescer",
    "leftSubtitle": "Teste o Pipeup por 7 dias com acesso completo. O plano define apenas quantas pessoas usam o sistema.",
    "noCreditCard": "Sem cartão de crédito",
    "cancelAnytime": "Cancele quando quiser",
    "title": "Escolha seu plano",
    "subtitle": "Você pode mudar de plano a qualquer momento",
    "loadingPlans": "Carregando planos...",
    "errorLoad": "Erro ao carregar planos. Por favor, recarregue a página ou entre em contato com o suporte.",
    "errorNote": "Nota: O endpoint /api/plans deve ser público (não requerer autenticação).",
    "trialNote": "Durante o trial, você já utiliza os limites do plano escolhido. Não pedimos cartão de crédito para começar.",
    "hasAccount": "Já tem uma conta?",
    "doLogin": "Fazer login"
  },
  "login": {
    "welcomeBack": "bem-vindo de volta",
    "subtitle": "faça login na sua conta pipeup",
    "email": "email",
    "emailPlaceholder": "seu@email.com",
    "password": "senha",
    "passwordPlaceholder": "••••••••",
    "rememberMe": "lembrar de mim",
    "forgotPassword": "esqueceu sua senha?",
    "submit": "entrar",
    "submitting": "entrando...",
    "noAccount": "Ainda não tem conta?",
    "createAccount": "Criar minha conta grátis",
    "footerPrefix": "Ao continuar, você concorda com nossos",
    "termsOfService": "Termos de Serviço",
    "footerAnd": "e",
    "privacyPolicy": "Política de Privacidade",
    "footerSuffix": ".",
    "logoAlt": "Pipeup Logo",
    "fillAllFields": "Por favor, preencha todos os campos.",
    "success": "Login realizado com sucesso!",
    "errorGeneric": "Erro ao fazer login. Tente novamente.",
    "errorAuthenticationFailed": "Falha na autenticacao. Verifique seu e-mail e senha e tente novamente.",
    "errorCredentials": "Verifique seu e-mail e senha e tente novamente.",
    "errorServiceUnavailable": "Serviço indisponível no momento. Por favor, tente novamente em alguns instantes.",
    "errorServer": "Erro temporário no servidor. Tente novamente em alguns instantes.",
    "subscriptionExpired": "Sua assinatura expirou. Regularize o pagamento para continuar utilizando o sistema.",
    "subscriptionPastDue": "Sua assinatura está com pendência de pagamento. Regularize o pagamento para continuar utilizando o sistema.",
    "trialExpired": "Seu trial expirou. Escolha um plano para continuar.",
    "noSubscription": "Você não possui uma assinatura ativa. Escolha um plano para continuar."
  },
  "subscriptionGuard": {
    "noSubscription": "Você não possui uma assinatura ativa. Escolha um plano para continuar.",
    "subscriptionExpired": "Sua assinatura expirou. Regularize o pagamento para continuar utilizando o sistema.",
    "subscriptionPastDue": "Sua assinatura está com pendência de pagamento. Regularize o pagamento para continuar utilizando o sistema.",
    "trialExpired": "Seu trial expirou. Escolha um plano para continuar.",
    "checkError": "Erro ao verificar assinatura. Tente novamente."
  },
  "billing": {
    "paywallNeedsAttention": "Sua assinatura precisa de atencao para continuar usando o sistema.",
    "previewLoadError": "Nao foi possivel carregar o resumo. Tente novamente.",
    "portalOpenError": "Nao foi possivel abrir. Tente novamente.",
    "subscriptionLoadError": "Erro ao carregar a assinatura. Tente novamente.",
    "statusTrial": "TRIAL",
    "statusActive": "ATIVO",
    "statusPending": "PENDENTE",
    "statusExpired": "EXPIRADO",
    "summaryPlan": "Plano {{planName}}",
    "summaryExtraUsers": "Usuarios adicionais ({{count}}x)",
    "summarySalesCopilot": "Sales Copilot ({{count}} usuarios)",
    "summaryAmountPerMonth": "{{amount}} / mes",
    "summaryTotalMonthly": "Total mensal: {{amount}}",
    "summaryChargedSemiannually": "Cobrado semestralmente: {{amount}}",
    "summaryChargedAnnually": "Cobrado anualmente: {{amount}}",
    "cycleMonthly": "Mensal",
    "cycleSemiannual": "Semestral",
    "cycleAnnual": "Anual"
  },
  "subscriptionCurrent": {
    "cancelSuccess": "Assinatura cancelada. Você continuara com acesso ate o fim do periodo atual.",
    "cancelError": "Erro ao cancelar. Tente novamente.",
    "paymentStatusPaid": "Pago",
    "paymentStatusPending": "Pendente",
    "paymentStatusCanceled": "Cancelado",
    "paymentMethodCreditCard": "Cartao",
    "paymentMethodBankSlip": "Boleto",
    "receiptUnavailable": "Comprovante nao disponivel."
  },
  "subscriptionCurrentTemplate": {
    "title": "Assinatura",
    "subtitle": "Gerencie seu plano",
    "changePlan": "Trocar plano",
    "cancelSubscription": "Cancelar assinatura",
    "loadingSubscription": "Carregando assinatura...",
    "planTitle": "Plano {{planCode}}",
    "activeBadge": "ATIVO",
    "value": "Valor",
    "cycle": "Ciclo",
    "nextBilling": "Proxima cobranca",
    "seats": "Assentos",
    "manageSeatsAndAddOns": "Gerenciar assentos e add-ons",
    "used": "Usados:",
    "usedSeatsValue": "{{used}} de {{total}} assentos",
    "includedInPlan": "Incluidos no plano:",
    "extraSeats": "+ {{count}} extras",
    "addOns": "Add-ons",
    "manageUsers": "Gerenciar usuarios",
    "enabledUsers": "{{count}} usuario(s) habilitado(s)",
    "perSubscription": "Por assinatura",
    "perUserSuffix": " / usuario",
    "loadingHistory": "Carregando historico...",
    "noPaymentsFound": "Nenhum pagamento encontrado",
    "historyWillAppear": "O historico aparecera aqui apos cobrancas.",
    "date": "Data",
    "description": "Descricao",
    "status": "Status",
    "currentPageReport": "Mostrando {first} a {last} de {totalRecords} pagamentos",
    "changePlanSoon": "Em breve voce podera alterar seu plano por aqui. Por enquanto, entre em contato com o suporte.",
    "close": "Fechar",
    "cancelConfirm": "Tem certeza que deseja cancelar a assinatura? Voce continuara com acesso ate {{date}}.",
    "cannotBeUndone": "Esta acao nao pode ser desfeita.",
    "cancel": "Cancelar",
    "canceling": "Cancelando..."
  },
  "subscriptionPayment": {
    "template": {
      "heroTitle": "Continue com acesso completo",
      "heroSubtitle": "Ative sua assinatura e mantenha seu time trabalhando sem interrupções.",
      "heroBulletSecure": "• Pagamento seguro",
      "heroBulletChangePlan": "• Você pode trocar de plano quando quiser",
      "logoAlt": "Logo Pipeup",
      "selectedPlanLabel": "Plano selecionado",
      "perMonth": "/mês",
      "planDescriptions": {
        "pro": "Tudo para operar vendas com eficiência",
        "scale": "Para gestão, escala e decisões estratégicas"
      },
      "changePlanAction": "trocar plano",
      "activateTitle": "Ative sua assinatura",
      "activateSubtitle": "Escolha a forma de pagamento para concluir.",
      "loading": "Carregando informações...",
      "changeSummaryTitle": "Resumo da alteração",
      "whatChangesNow": "O que muda agora:",
      "whatChangesNextCycle": "O que muda no próximo ciclo:",
      "chargeNow": "Valor a ser cobrado agora:",
      "nextInvoiceEstimate": "Valor estimado da próxima fatura:",
      "selectPaymentAndConfirm": "Selecione a forma de pagamento abaixo e confirme.",
      "confirmAndPay": "Confirmar e pagar",
      "processing": "Processando...",
      "confirmChange": "Confirmar alteração",
      "scheduling": "Agendando...",
      "back": "Voltar",
      "choosePaymentMethod": "Escolha o método de pagamento",
      "activateSubscription": "Ativar assinatura",
      "calculating": "Calculando...",
      "keepSelectedPlan": "Você continuará no plano selecionado.",
      "paymentViaPix": "Pagamento via PIX",
      "paymentViaCard": "Pagamento via Cartão",
      "paymentViaBankSlip": "Pagamento via Boleto",
      "amountToPay": "Valor a pagar:",
      "semiannualSuffix": "(semestral)",
      "annualSuffix": "(anual)",
      "expiresIn": "Expira em:",
      "paymentExpiredCreateNew": "Pagamento expirado. Crie um novo checkout.",
      "qrCodeMissing": "Erro: QR Code não foi retornado. Verifique o console para mais detalhes.",
      "paymentUrlMissingDetails": "Erro: URL de pagamento não foi retornada. Verifique o console para mais detalhes.",
      "qrCodeAlt": "QR Code PIX",
      "pixCodeLabel": "Código PIX (Copiar e Colar):",
      "pixCodeShort": "Código PIX",
      "copy": "Copiar",
      "pixInstructionsLine1": "Escaneie o QR Code com o app do seu banco",
      "pixInstructionsLine2": "ou copie o código PIX.",
      "awaitingPaymentConfirmation": "Aguardando confirmação do pagamento...",
      "paymentConfirmedRedirecting": "Pagamento confirmado! Redirecionando...",
      "secureCheckoutRedirect": "Você será redirecionado para o checkout seguro.",
      "goToCheckout": "Ir para checkout",
      "downloadBankSlipPrompt": "Clique no botão abaixo para baixar o boleto bancário",
      "downloadBankSlip": "Baixar Boleto",
      "bankSlipInstructions": "O boleto vence em até 3 dias úteis. Após o pagamento, sua assinatura será ativada automaticamente.",
      "chooseAnotherPaymentMethod": "Escolher outro método de pagamento",
      "cancelAndGoBack": "Cancelar e voltar",
      "changePlanModalTitle": "Alterar Plano",
      "planOptionDescriptions": {
        "pro": "Para times pequenos e médios que querem operar vendas com eficiência",
        "scale": "Para gestão, escala e decisões estratégicas"
      },
      "upToIncludedUsers": "Até {{count}} usuários incluídos",
      "currentPlan": "Plano Atual",
      "select": "Selecionar",
      "changing": "Alterando..."
    },
    "paymentMethods": {
      "pix": {
        "label": "PIX",
        "description": "Pagamento instantâneo"
      },
      "creditCard": {
        "label": "Cartão de Crédito",
        "description": "Recorrente mensal"
      },
      "bankSlip": {
        "label": "Boleto",
        "description": "Compensação em até 3 dias"
      }
    },
    "statusMessage": {
      "default": "Sua assinatura expirou ou está com pendência. Regularize o pagamento para continuar utilizando o sistema."
    },
    "toasts": {
      "selectPaymentMethod": "Por favor, selecione um método de pagamento",
      "selectBillingCycle": "Por favor, selecione um ciclo de cobrança",
      "selectPaymentMethodFirst": "Selecione a forma de pagamento primeiro.",
      "selectPaymentMethodForConfirmation": "Selecione a forma de pagamento."
    },
    "warnings": {
      "mockQrCode": "⚠️ Usando QR Code mock (backend não retornou dados)"
    },
    "errors": {
      "backendMethodMismatch": "Erro: Backend retornou método \"{{backendMethod}}\" mas você selecionou \"{{selectedMethod}}\"",
      "paymentUrlMissing": "Erro: URL de pagamento não foi retornada pelo servidor para {{paymentMethod}}",
      "unknownPaymentMethod": "Erro: Método de pagamento desconhecido: {{paymentMethod}}",
      "createCheckout": "Erro ao criar checkout. Tente novamente.",
      "checkoutEndpointNotFound": "Endpoint de checkout não encontrado. Verifique se o backend está configurado corretamente.",
      "invalidData": "Dados inválidos. Verifique as informações e tente novamente.",
      "sessionExpired": "Sessão expirada. Faça login novamente.",
      "server": "Erro no servidor. Tente novamente em alguns instantes.",
      "generateQrCode": "Erro ao gerar QR Code",
      "copyToClipboard": "Erro ao copiar para a área de transferência",
      "changePlan": "Erro ao alterar plano. Tente novamente.",
      "scheduleChange": "Erro ao agendar alteração. Tente novamente."
    },
    "success": {
      "copiedToClipboard": "{{label}} copiado para a área de transferência!",
      "changeScheduled": "Alteração programada para o próximo ciclo.",
      "paymentConfirmedRedirecting": "Pagamento confirmado! Redirecionando..."
    },
    "changeSummary": {
      "planChanged": "Plano alterado para {{planName}} ({{cycleName}}).",
      "immediateProrated": "A alteração será aplicada imediatamente e o valor proporcional será cobrado agora.",
      "nextCycle": "A alteração será aplicada no próximo ciclo de cobrança.",
      "cycleChanged": "Ciclo alterado para {{cycleName}}.",
      "immediateCharge": "A alteração será aplicada imediatamente e o valor será cobrado agora.",
      "monthlyNextCycle": "Cobrança mensal a partir do próximo ciclo.",
      "monthlyAtPeriodEnd": "A mudança para cobrança mensal será aplicada ao final do período contratado."
    },
    "expiration": {
      "expired": "Expirado"
    }
  },
  "companyPreferences": {
    "title": "Preferências",
    "language": {
      "label": "Idioma da plataforma",
      "helper": "Ajusta os textos do sistema. Você pode alterar a qualquer momento."
    },
    "accentColor": {
      "title": "Cor de destaque",
      "description": "Personalize botões e destaques em propostas e PDFs (escopo limitado).",
      "label": "Cor de destaque",
      "contrastHint": "A cor do texto é ajustada automaticamente para melhor contraste."
    }
  },
  "sidebar": {
    "sectionGeneral": "geral",
    "sectionTools": "ferramentas",
    "sectionAdmin": "administração",
    "dashboard": "dashboard",
    "inbox": "inbox",
    "agenda": "agenda",
    "leads": "leads",
    "pipeline": "pipeline",
    "registrations": "cadastros",
    "contacts": "contatos",
    "companies": "empresas",
    "automations": "automações",
    "integrations": "integrações",
    "reports": "relatórios",
    "commercial": "comercial",
    "pipelines": "pipelines",
    "lostReasons": "motivos de perda",
    "customFields": "campos extras",
    "brands": "marcas",
    "products": "produtos",
    "proposalTemplates": "propostas",
    "channels": "canais",
    "channelsConfig": "configurações",
    "marketing": "marketing",
    "marketingTags": "tags",
    "marketingSegments": "segmentos",
    "marketingTemplates": "templates",
    "marketingCampaigns": "campanhas",
    "account": "conta",
    "company": "empresa",
    "users": "usuários",
    "profiles": "perfis",
    "subscription": "assinatura"
  },
  "header": {
    "create": "Criar",
    "newLead": "Novo lead",
    "newDeal": "Novo negócio",
    "newActivity": "Nova atividade",
    "newProposal": "Nova proposta",
    "notifications": "Notificações",
    "notificationsCount": "{{count}} notificações",
    "markAllAsRead": "Marcar todas como lidas",
    "noNotifications": "Nenhuma notificação",
    "user": "Usuário",
    "company": "Empresa",
    "profile": "Perfil",
    "logout": "Sair",
    "avatar": "Avatar",
    "trialExpired": "Trial encerrado",
    "trialDaysOne": "Trial • 1 dia",
    "trialDays": "Trial • {{days}} dias",
    "trialTooltipWarning": "Seu período de trial está chegando ao fim.",
    "trialTooltipDanger": "Seu trial está quase encerrando. Faça upgrade para continuar usando o sistema.",
    "roleMember": "Membro",
    "relativeNow": "agora",
    "relativeMin": "há {{count}} min",
    "relativeHour": "há {{count}}h",
    "relativeDay": "há {{count}}d"
  },
  "account": {
    "title": "Meus Dados",
    "subtitle": "Gerencie suas informações pessoais",
    "loading": "Carregando seus dados...",
    "identificationTitle": "Informações de Identificação",
    "profilePhoto": "Foto de Perfil",
    "avatarPlaceholder": "https://exemplo.com/avatar.jpg",
    "changePhoto": "Alterar Foto",
    "selectPhoto": "Selecionar",
    "avatarHintNoPhoto": "Cole a URL da sua foto de perfil ou selecione uma imagem",
    "avatarHintWithPhoto": "Clique em \"Alterar Foto\" para trocar sua foto de perfil",
    "email": "Email",
    "company": "Empresa",
    "profile": "Perfil",
    "noValue": "—",
    "personalInfoTitle": "Informações Pessoais",
    "name": "Nome",
    "namePlaceholder": "Ex: João Silva",
    "phone": "Telefone",
    "phonePlaceholder": "(11) 99999-9999",
    "sameNumberWhatsApp": "Mesmo número usado para WhatsApp",
    "whatsappNumber": "Número do WhatsApp",
    "timezone": "Fuso Horário",
    "timezonePlaceholder": "Selecione um fuso horário",
    "saving": "Salvando...",
    "saveChanges": "Salvar Alterações",
    "errors": {
      "load": "Erro ao carregar seus dados. Tente novamente.",
      "update": "Erro ao atualizar seus dados. Tente novamente.",
      "nameRequired": "O nome é obrigatório",
      "phoneRequired": "O telefone é obrigatório",
      "invalidFormat": "Formato inválido. Use: +5511999999999",
      "timezoneRequired": "O fuso horário é obrigatório",
      "timezoneInvalid": "Formato de timezone inválido. Use formato IANA (ex: America/Sao_Paulo)",
      "imageOnly": "Apenas arquivos de imagem são permitidos (JPG, PNG, GIF, WEBP).",
      "fileSize": "O arquivo deve ter no máximo 2.5MB.",
      "imageDimensions": "A imagem deve ter no máximo 198x198 pixels.",
      "imageLoad": "Erro ao carregar a imagem.",
      "fileRead": "Erro ao ler o arquivo.",
      "avatarUpload": "Erro ao fazer upload do avatar."
    },
    "success": {
      "updated": "Dados atualizados com sucesso!",
      "avatarUpdated": "Avatar atualizado com sucesso!"
    }
  },
  "subscription": {
    "title": "Assinatura",
    "subtitle": "Gerencie plano, assentos, complementos e pagamentos da sua conta.",
    "tabPrincipal": "Principal",
    "tabHistorico": "Histórico",
    "loading": "Carregando assinatura...",
    "errorLoadTitle": "Erro ao carregar assinatura",
    "errorLoadMessage": "Não foi possível carregar as informações da assinatura.",
    "tryAgain": "Tentar novamente",
    "noSubscriptionTitle": "Nenhuma assinatura ativa",
    "noSubscriptionChoose": "Escolha um plano para começar:",
    "upToUsers": "Até {{count}} usuários incluídos",
    "startTrial": "Iniciar período de teste",
    "perMonth": "/mês",
    "alertPastDueTitle": "Assinatura com pendência",
    "alertPastDueMessage": "Seu pagamento está em atraso. Regularize para continuar utilizando o sistema.",
    "alertExpiredMessage": "Sua assinatura expirou. Renove para continuar utilizando o sistema.",
    "regularize": "Regularizar",
    "billingCycle": "Ciclo de cobrança:",
    "nextBilling": "Próxima cobrança:",
    "trialEndsOn": "Seu período de teste termina em {{date}}",
    "accountUpToDate": "Conta em dia",
    "attentionRegularize": "Atenção: regularize para manter acesso completo",
    "whatYouHaveContracted": "O que você tem contratado",
    "plan": "Plano",
    "extraSeats": "Assentos adicionais ({{count}})",
    "totalEstimated": "Total estimado",
    "doUpgrade": "Fazer upgrade",
    "changePlan": "Alterar Plano",
    "cancelSubscription": "Cancelar Assinatura",
    "scheduledChangeTitle": "Alteração programada para o próximo ciclo",
    "cancelScheduledTitle": "Cancelamento programado",
    "cancelScheduledMessage": "Sua assinatura será cancelada ao final do período atual. Você mantém acesso até lá.",
    "changePlanModalTitle": "Alterar plano",
    "currentPlan": "Plano atual:",
    "loadingPlans": "Carregando planos...",
    "whatChangesNow": "O que muda agora:",
    "whatChangesNextCycle": "O que muda no próximo ciclo:",
    "chargeNow": "Valor a ser cobrado agora:",
    "nextInvoiceEstimate": "Valor estimado da próxima fatura:",
    "paymentMethod": "Forma de pagamento",
    "confirmAndPay": "Confirmar e pagar",
    "processing": "Processando...",
    "confirmChange": "Confirmar alteração",
    "scheduling": "Agendando...",
    "back": "Voltar",
    "seatsTitle": "Assentos",
    "seatsSubtitle": "Gerencie quem ocupa assentos e custos de excedente.",
    "additionPerSeat": "Adição: {{price}} / assento",
    "manageSeats": "Gerenciar assentos",
    "used": "Usados:",
    "ofSeats": "{{used}} de {{total}} assentos",
    "includedInPlan": "Incluídos no plano:",
    "extraSeatsBadge": "Assentos extras: {{count}}",
    "addonsTitle": "Complementos",
    "addonsSubtitle": "Ative recursos adicionais conforme necessidade. Complementos e assentos extras são cobrados na hora.",
    "available": "Disponíveis",
    "perUser": "Por usuário",
    "perUserShort": "usuário",
    "perSubscription": "Por assinatura",
    "contract": "Contratar",
    "contracted": "Contratados",
    "addition": "Adição",
    "additionPerUser": "Adição: {{price}} / usuário",
    "manageUsers": "Gerenciar usuários",
    "historyTitle": "Histórico de pagamentos",
    "historySubtitle": "Consulte faturas, status e comprovantes.",
    "loadingHistory": "Carregando histórico...",
    "noPayments": "Nenhum pagamento encontrado ainda.",
    "period": "Período",
    "planCol": "Plano",
    "value": "Valor",
    "status": "Status",
    "method": "Método",
    "dueDate": "Vencimento",
    "paidOn": "Pago em",
    "actions": "Ações",
    "downloadPdf": "Baixar PDF",
    "statusPaid": "Pago",
    "statusPending": "Pendente",
    "statusFailed": "Falhou",
    "statusRefunded": "Reembolsado",
    "modalSeatsTitle": "Assentos do plano",
    "modalSeatsSubtitle": "Gerencie usuários e adicione novos assentos",
    "addNewSeat": "Adicionar novo assento",
    "addSeatHint": "A cobrança é imediata e proporcional ao período atual. Depois, você poderá definir quem usará o assento.",
    "addSeatHint2": "Nenhuma cobrança recorrente adicional é criada sem sua confirmação.",
    "quantityNewSeats": "Quantidade de novos assentos",
    "addSeatAndPay": "Adicionar assento e pagar agora",
    "trialNoExtraSeats": "Durante o período de teste não é possível adicionar assentos extras. Após a primeira cobrança, você poderá adicionar e pagar na hora.",
    "cancelModalTitle": "Cancelar Assinatura",
    "cancelModalRegistered": "Cancelamento registrado",
    "cancelModalConfirmText": "Ao confirmar, sua assinatura será cancelada ao fim do período atual.",
    "cancelModalAccessUntil": "Você mantém acesso até lá.",
    "cancelModalTypeCompany": "Para confirmar, digite o nome da empresa",
    "noKeepSubscription": "Não, manter assinatura",
    "confirmCancellation": "Confirmar cancelamento",
    "registeringCancellation": "Registrando cancelamento...",
    "refundEligible": "Você tem direito a reembolso. Data limite: {{date}}.",
    "effectiveCancellationOn": "Cancelamento efetivo em:",
    "close": "Fechar",
    "removeAccessTitle": "Remover acesso?",
    "removeAccessUserLoses": "Este usuário perderá acesso ao workspace.",
    "removeAccessSeatFreed": "O assento será liberado imediatamente.",
    "removeAccessDataPreserved": "Os dados e histórico permanecerão preservados.",
    "removeAccess": "Remover acesso",
    "removing": "Removendo…",
    "contractAddon": "Contratar:",
    "manageAddonUsers": "Gerencie quais usuários têm acesso a este complemento",
    "willBeEnabled": "Será habilitado",
    "enable": "Habilitar",
    "unmark": "Desmarcar",
    "disabled": "Desabilitar",
    "enabled": "Habilitado",
    "usersWithAddon": "{{count}} usuário(s) com {{name}} ativo",
    "selectUsersToEnable": "Selecione os usuários acima para habilitar o {{name}}. A cobrança é imediata e proporcional ao período atual.",
    "contractAndPay": "Contratar e pagar",
    "enableAddonAndPay": "Habilitar {{name}} e pagar agora",
    "chargeImmediateHint": "A cobrança é imediata e proporcional ao período atual. Depois você pode habilitar para mais usuários em Gerenciar usuários.",
    "statusTrial": "Período de teste",
    "statusActive": "Ativa",
    "statusPastDue": "Pagamento pendente",
    "statusCanceled": "Cancelada",
    "statusExpired": "Expirada",
    "daysRemaining": "{{count}} dias restantes"
  },
  "dashboard": {
    "title": "Dashboard",
    "attention": {
      "title": "Atenção imediata",
      "dealsCount": "{{count}} negócios",
      "daysNoAction": "{{days}} dias sem ação",
      "viewDeals": "Ver negócios",
      "empty": "Nenhum negócio precisa de atenção no momento."
    },
    "myActivities": {
      "title": "Minhas atividades",
      "overdue": "ATRASADA",
      "empty": "Nenhuma atividade para hoje"
    },
    "hotDeals": {
      "title": "Negócios mais próximos de fechar",
      "empty": "Nenhum negócio próximo de fechar no momento."
    },
    "pipelineSummary": {
      "title": "Resumo do pipeline",
      "lastDays": "Últimos {{days}} dias",
      "createDeal": "Criar negócio",
      "selectPipeline": "Selecione um pipeline",
      "viewFullPipeline": "Ver pipeline completo",
      "retry": "Tentar novamente",
      "noPipelines": "Você ainda não possui pipelines cadastrados.",
      "createPipeline": "Criar pipeline",
      "topFunnel": "Topo do funil",
      "middleFunnel": "Meio do funil",
      "bottomFunnel": "Fundo do funil"
    },
    "summaryBox": {
      "deals": "negócios",
      "dealsWithCount": "{{count}} negócios",
      "stages": "etapas",
      "oneStage": "1 etapa",
    "stageCount": "{{count}} etapas",
      "totalInPeriod": "Total no período selecionado",
      "noDealsInPeriod": "Nenhum negócio neste período",
      "viewDeals": "Ver negócios",
      "addDeal": "Adicionar negócio"
    },
    "conversion": {
      "label": "Taxa de conversão",
      "noData": "Sem dados",
      "lastDays": "Últimos {{days}} dias",
      "noDataInPeriod": "Sem dados no período",
      "viewWon": "Ver ganhos no período",
      "viewCreated": "Ver criados no período",
      "ratioLabel": "{{won}}/{{created}} ganhos",
      "wonOfCreated": "{{won}} ganhos de {{created}} criados",
      "vsPrevious": "vs período anterior"
    },
    "performance": {
      "title": "Performance",
      "last30Days": "Últimos 30 dias",
      "noDataInPeriod": "Sem dados no período",
      "loading": "Carregando…",
      "loadError": "Não foi possível carregar os dados.",
      "noDataSelected": "Sem dados no período selecionado.",
      "chartLeadsCreated": "Leads criados",
      "chartDealsCreated": "Deals criados",
      "chartDealsWon": "Deals ganhos",
      "chartDealsLost": "Deals perdidos"
    },
    "errors": {
      "sessionExpired": "Sessão expirada",
      "notFound": "Recurso não encontrado",
      "tooManyRequests": "Muitas requisições. Aguarde um momento e tente novamente.",
      "serverError": "Erro no servidor. Tente novamente.",
      "noConnection": "Sem conexão com o servidor",
      "loadError": "Erro ao carregar dados"
    },
    "attentionTitles": {
      "dealsNoActivity3": "Negócios sem atividade há 3 dias",
      "proposals48h": "Propostas enviadas há +48h sem resposta",
      "dealsStuck7": "Negócios parados no mesmo estágio há 7 dias"
    },
    "noValue": "Sem valor",
    "na": "N/A"
  },
  "automations": {
    "title": "Automações",
    "subtitle": "Crie regras simples do tipo Quando algo acontecer → Fazer uma ação.",
    "newAutomation": "Nova Automação",
    "searchPlaceholder": "Buscar automação…",
    "filterStatusAll": "Todas",
    "filterStatusActive": "Ativas",
    "filterStatusInactive": "Inativas",
    "filterEventAll": "Todos os tipos",
    "sortRecent": "Mais recentes",
    "sortName": "Nome A–Z",
    "sortStatus": "Status (ativas primeiro)",
    "search": "Buscar",
    "loading": "Carregando automações...",
    "emptyTitle": "Você ainda não tem automações.",
    "emptySubtitle": "Crie sua primeira automação para automatizar tarefas repetitivas.",
    "createFirst": "Criar primeira automação",
    "emptyFiltered": "Nenhuma automação encontrada para os filtros selecionados.",
    "clearFilters": "Limpar filtros",
    "statusActive": "Ativa",
    "statusInactive": "Inativa",
    "createdAt": "Criada em",
    "updatedAt": "Atualizada em",
    "editTitle": "Editar automação",
    "deleteTitle": "Excluir automação",
    "paginatorTemplate": "Mostrando {first} a {last} de {totalRecords} automações",
    "deleteModal": {
      "title": "Excluir Automação",
      "message": "Tem certeza que deseja excluir a automação \"{{name}}\"?",
      "warning": "Esta ação não pode ser desfeita.",
      "delete": "Excluir",
      "deleting": "Excluindo..."
    },
    "modal": {
      "titleNew": "Nova Automação",
      "titleEdit": "Editar Automação",
      "loadingDetails": "Carregando detalhes da automação...",
      "nameLabel": "Nome da Automação",
      "namePlaceholder": "Ex: Criar atividade após proposta enviada",
      "nameChars": "{{count}}/80 caracteres",
      "applyInLabel": "Aplicar em",
      "applyInHelper": "Define onde a automação será aplicada",
      "selectScope": "Selecione...",
      "whenLabel": "Quando",
      "selectEvent": "Selecione um evento",
      "pipelineOptional": "Pipeline (opcional)",
      "allPipelines": "Todos os pipelines",
      "pipelineHelper": "Se não selecionar, aplica a qualquer pipeline",
      "forStageOptional": "Para etapa (opcional)",
      "selectStage": "Selecione uma etapa",
      "selectStageFirst": "Selecione primeiro o pipeline para habilitar",
      "templateOptional": "Modelo de proposta (opcional)",
      "allTemplates": "Todos os modelos",
      "useCondition": "Usar condição",
      "fieldLabel": "Campo",
      "selectField": "Selecione um campo",
      "operatorLabel": "Operador",
      "selectOperator": "Selecione",
      "valueLabel": "Valor",
      "operatorEquals": "é",
      "operatorContains": "contém",
      "operatorNotContains": "não contém",
      "operatorIsEmpty": "está vazio",
      "operatorIsNotEmpty": "não está vazio",
      "doLabel": "Fazer",
      "selectAction": "Selecione uma ação",
      "activityTypeLabel": "Tipo de atividade",
      "activityTypeSelect": "Selecione",
      "activityTypeCall": "Ligação",
      "activityTypeMeeting": "Reunião",
      "activityTypeTask": "Tarefa",
      "activityTypeFollowUp": "Follow-up",
      "titleSubjectLabel": "Título/Assunto",
      "titlePlaceholder": "Ex: Ligar em 1 dia",
      "descriptionOptional": "Descrição (opcional)",
      "dueLabel": "Vencimento",
      "dueImmediate": "Imediato",
      "dueDays": "Em X dias",
      "daysLabel": "Dias",
      "responsibleLabel": "Responsável",
      "keepOwner": "Manter responsável atual",
      "assignOwnerOption": "Definir responsável",
      "selectResponsible": "Selecione um responsável",
      "stageDestLabel": "Etapa destino",
      "changeStageHelper": "Altera a etapa dentro do mesmo pipeline",
      "pipelineDestLabel": "Pipeline destino",
      "selectPipeline": "Selecione um pipeline",
      "moveStageHelper": "Move o item para outro pipeline e define a nova etapa",
      "optionLabel": "Opção",
      "overwriteOwner": "Sobrescrever responsável atual",
      "assignOnlyIfEmpty": "Atribuir apenas se estiver vazio",
      "summaryTitle": "Resumo",
      "summaryPlaceholder": "Preencha o escopo, evento e ação para ver o resumo",
      "fixErrors": "Corrija os seguintes erros:",
      "saving": "Salvando..."
    },
    "summary": {
      "scopeIn": "Em {{scope}}: ",
      "when": "Quando {{event}}",
      "toStage": " para {{stage}}",
      "condition": ", se {{field}} {{operator}} {{value}}",
      "action": " → {{action}}",
      "moveTo": " para {{pipeline}}",
      "moveStage": " / {{stage}}"
    },
    "operators": {
      "equals": "é",
      "contains": "contém",
      "notContains": "não contém",
      "isEmpty": "está vazio",
      "isNotEmpty": "não está vazio",
      "greaterThan": "maior que",
      "lessThan": "menor que",
      "isTrue": "é verdadeiro",
      "isFalse": "é falso",
      "notEquals": "não é",
      "before": "antes de",
      "after": "depois de"
    },
    "scopes": {
      "deal": "Deals",
      "lead": "Leads",
      "proposal": "Propostas"
    }
  },
  "agenda": {
    "title": "Agenda",
    "subtitle": "Gerencie suas atividades agendadas",
    "searchPlaceholder": "Buscar por negócio, contato ou empresa…",
    "filterFollowUp": "Follow-up",
    "filterTask": "Tarefa",
    "filterMeeting": "Reunião",
    "summaryTitle": "Resumo do dia",
    "summaryFollowUps": "Follow-ups:",
    "summaryTasks": "Tarefas:",
    "summaryMeetings": "Reuniões:",
    "summaryOverdue": "Atrasadas:",
    "noActivitiesDay": "Nenhuma atividade para este dia.",
    "overdueTitle": "Atrasadas",
    "overdueCountOne": "atrasada",
    "overdueCountMany": "atrasadas",
    "viewAll": "Ver todas",
    "noOverdue": "Nenhuma atividade atrasada.",
    "activitiesTitle": "Atividades",
    "tabToday": "Hoje",
    "tabNext7": "Próximos 7 dias",
    "tabNext30": "Próximos 30 dias",
    "tabOverdue": "Atrasados",
    "tabHint": "Clique em um dia no calendário para desativar a seleção",
    "loading": "Carregando atividades...",
    "emptyTitle": "Nenhuma atividade para este dia.",
    "emptyAdjustFilters": "Tente ajustar os filtros de busca",
    "emptyHint": "Suas atividades agendadas aparecerão aqui",
    "noContact": "Sem contato",
    "noCompany": "Sem empresa",
    "overdueDays": "Atrasado há {{days}} {{daysLabel}}",
    "overdueDaysOne": "dia",
    "overdueDaysMany": "dias",
    "openDeal": "Abrir negócio",
    "noDealLinked": "Esta atividade não está vinculada a um negócio",
    "complete": "Concluir",
    "reschedule": "Reagendar",
    "modalCompleteTitle": "Concluir Atividade",
    "modalCompleteQuestion": "Deseja adicionar uma nota sobre o resultado desta atividade?",
    "modalCompleteLabel": "Motivo/Resultado (opcional)",
    "modalCompletePlaceholder": "Descreva o resultado ou motivo da conclusão...",
    "completing": "Concluindo...",
    "modalRescheduleTitle": "Reagendar Atividade",
    "modalRescheduleLabel": "Nova Data e Hora",
    "confirm": "Confirmar",
    "todayAt": "Hoje {{time}}",
    "weekdayDom": "dom.",
    "weekdayMon": "seg.",
    "weekdayTue": "ter.",
    "weekdayWed": "qua.",
    "weekdayThu": "qui.",
    "weekdayFri": "sex.",
    "weekdaySat": "sáb.",
    "monthJan": "jan",
    "monthFeb": "fev",
    "monthMar": "mar",
    "monthApr": "abr",
    "monthMay": "mai",
    "monthJun": "jun",
    "monthJul": "jul",
    "monthAug": "ago",
    "monthSep": "set",
    "monthOct": "out",
    "monthNov": "nov",
    "monthDec": "dez",
    "channelCall": "Ligação",
    "channelEmail": "Email",
    "channelWhatsApp": "WhatsApp",
    "noteCompletionSubject": "Conclusão: {{subject}}",
    "errors": {
      "load": "Erro ao carregar agenda. Tente novamente.",
      "noDeal": "Esta atividade não está vinculada a um negócio.",
      "loadDeal": "Erro ao carregar negócio. Tente novamente.",
      "complete": "Erro ao concluir atividade. Tente novamente.",
      "reschedule": "Erro ao reagendar atividade. Tente novamente."
    },
    "toast": {
      "completeWithNote": "Atividade concluída e nota registrada com sucesso!",
      "complete": "Atividade concluída com sucesso!",
      "reschedule": "Atividade reagendada com sucesso!"
    }
  },
  "crmTags": {
    "label": "Tags",
    "addTagPlaceholder": "Adicionar tag…",
    "searchPlaceholder": "Buscar tag…",
    "helperText": "Use tags para segmentar campanhas e automações.",
    "removeTag": "Remover tag",
    "noTagsFound": "Nenhuma tag encontrada.",
    "loading": "Carregando tags…",
    "toastAdded": "Tag adicionada",
    "toastRemoved": "Tag removida",
    "toastError": "Não foi possível atualizar tags. Tente novamente.",
    "tagsColumn": "Tags",
    "tagsQuickAction": "Tags",
    "manageTags": "Gerenciar tags",
    "tagsCountTooltip": "{{count}} tags — clique para gerenciar",
    "noTags": "—",
    "noTagsAttributed": "Nenhuma tag atribuída"
  },
  "leads": {
    "title": "Leads",
    "subtitle": "Gerencie seus leads (Pessoas e Organizações)",
    "import": "Importar",
    "importFile": "Importar arquivo (.xlsx)",
    "downloadTemplate": "Baixar modelo (.xlsx)",
    "newLead": "Novo Lead",
    "searchPlaceholder": "Buscar leads...",
    "filterAllTypes": "Todos os tipos",
    "typePerson": "Pessoa",
    "typeOrganization": "Empresa",
    "search": "Buscar",
    "loading": "Carregando leads...",
    "emptyTitle": "Nenhum lead encontrado",
    "emptyWithFilters": "Tente ajustar os filtros de busca",
    "emptyNoFilters": "Comece criando seu primeiro lead",
    "tableLead": "Lead",
    "tableType": "Tipo",
    "tableStatus": "Status",
    "tableContact": "Contato",
    "tableOwner": "Responsável",
    "tableCreatedAt": "Criado em",
    "tableActions": "Ações",
    "whatsappAvailable": "WhatsApp disponível",
    "viewActivities": "Ver atividades",
    "editLead": "Editar lead",
    "convertToDeal": "Transformar em oportunidade",
    "deleteLead": "Excluir lead",
    "paginatorReport": "Mostrando {first} a {last} de {totalRecords} leads",
    "deleteModal": {
      "title": "Excluir Lead",
      "message": "Tem certeza que deseja excluir o lead",
      "warning": "Esta ação não pode ser desfeita.",
      "cancel": "Cancelar",
      "delete": "Excluir",
      "deleting": "Excluindo..."
    },
    "detail": {
      "breadcrumbLeads": "Leads",
      "loading": "Carregando...",
      "loadingLead": "Carregando lead...",
      "edit": "Editar",
      "activities": "Atividades",
      "newActivity": "Nova atividade",
      "filterAll": "Todas",
      "loadingActivities": "Carregando atividades...",
      "noActivities": "Nenhuma atividade registrada",
      "noActivitiesHint": "Registre a primeira atividade para começar",
      "newActivityTitle": "Nova Atividade",
      "type": "Tipo",
      "dateTime": "Data/Hora",
      "subject": "Assunto",
      "subjectPlaceholder": "Ex: Ligação de follow-up",
      "description": "Descrição",
      "descriptionPlaceholder": "Detalhes da atividade...",
      "cancel": "Cancelar",
      "save": "Salvar",
      "result": "Resultado",
      "showMore": "Mostrar mais",
      "showLess": "Mostrar menos",
      "completed": "Concluída",
      "reopen": "Reabrir",
      "delete": "Excluir",
      "identification": "Identificação",
      "responsible": "Responsável",
      "active": "Ativo",
      "inactive": "Inativo",
      "contacts": "Contatos",
      "contact": "Contato",
      "tradeName": "Nome Fantasia",
      "cnpj": "CNPJ",
      "noContact": "Nenhum contato cadastrado",
      "actions": "Ações",
      "convertToDeal": "Converter em Negócio",
      "archiveLead": "Arquivar Lead",
      "phoneVerified": "Telefone verificado",
      "whatsappVerified": "WhatsApp verificado",
      "whatsappAvailable": "WhatsApp Disponível"
    },
    "drawer": {
      "editLead": "Editar Lead",
      "newLead": "Novo Lead",
      "configureLeadData": "Configure os dados do lead",
      "type": "Tipo",
      "person": "Pessoa",
      "organization": "Empresa",
      "name": "Nome",
      "contactName": "Nome do Contato",
      "contactNameHintPerson": "Geralmente igual ao nome",
      "contactNameHintOrg": "Nome da pessoa que responde pela empresa",
      "email": "Email",
      "phone": "Telefone",
      "phoneRequired": "Telefone é obrigatório.",
      "phoneE164": "Telefone deve estar no formato E.164 (ex: +5511987654321 ou +31612345678).",
      "phoneFormatHint": "Selecione o país e digite o número (será convertido para E.164).",
      "whatsappOptIn": "Permitir envio de mensagens via WhatsApp",
      "position": "Cargo/Posição",
      "positionPlaceholder": "Ex: Gerente de TI",
      "company": "Empresa",
      "companyPlaceholder": "Ex: TechPro Serviços",
      "tradeName": "Nome Fantasia",
      "tradeNamePlaceholder": "Ex: TechPro",
      "cnpj": "CNPJ",
      "cnpjPlaceholder": "12.345.678/0001-90",
      "cnpjDigitsError": "CNPJ deve ter 14 dígitos.",
      "website": "Website",
      "websitePlaceholder": "https://exemplo.com.br",
      "industry": "Indústria",
      "industryPlaceholder": "Ex: Tecnologia",
      "size": "Tamanho",
      "select": "Selecione",
      "sizeSmall": "Pequena",
      "sizeMedium": "Média",
      "sizeLarge": "Grande",
      "sizeEnterprise": "Enterprise",
      "address": "Endereço",
      "country": "País",
      "countryPlaceholder": "Ex: Brasil",
      "state": "Estado",
      "statePlaceholder": "Ex: SP",
      "city": "Cidade",
      "cityPlaceholder": "Ex: São Paulo",
      "addressLine1": "Endereço",
      "addressLine1Placeholder": "Ex: Av. Paulista, 1000",
      "complement": "Complemento",
      "complementPlaceholder": "Ex: Sala 101",
      "zipCode": "CEP",
      "zipCodePlaceholder": "01310-100",
      "source": "Origem",
      "status": "Status",
      "statusActive": "Ativo",
      "statusInactive": "Inativo",
      "statusNew": "Novo",
      "statusInContact": "Em Contato",
      "statusQualified": "Qualificado",
      "description": "Descrição",
      "descriptionPlaceholder": "Observações sobre o lead...",
      "responsible": "Responsável",
      "selectResponsible": "Selecione um responsável",
      "customFields": "Campos Personalizados",
      "createDealAfterSave": "Criar oportunidade após salvar",
      "pipeline": "Pipeline",
      "selectPipeline": "Selecione um pipeline",
      "initialStage": "Etapa Inicial",
      "selectStage": "Selecione uma etapa",
      "selectPipelineFirst": "Selecione primeiro um pipeline",
      "cancel": "Cancelar",
      "saveChanges": "Salvar Alterações",
      "saveLead": "Salvar Lead",
      "saving": "Salvando...",
      "namePlaceholderPerson": "Ex: João Pereira",
      "namePlaceholderOrg": "Ex: TechPro Serviços Ltda",
      "contactPlaceholderPerson": "Ex: João Pereira",
      "contactPlaceholderOrg": "Ex: Maria Santos (pessoa que responde pela empresa)",
      "emailPlaceholder": "exemplo@email.com",
      "emailPlaceholderOrg": "contato@empresa.com.br"
    },
    "convertModal": {
      "title": "Converter em Negócio",
      "subtitle": "Crie uma oportunidade a partir deste lead",
      "pipeline": "Pipeline",
      "stage": "Etapa",
      "selectPipeline": "Selecione um pipeline",
      "selectStage": "Selecione uma etapa",
      "selectPipelineFirst": "Selecione um pipeline primeiro",
      "responsible": "Responsável",
      "notAssigned": "Não atribuído",
      "dealName": "Nome do Negócio",
      "dealNamePlaceholder": "Ex: Negócio com João Silva",
      "estimatedValue": "Valor Estimado",
      "expectedDate": "Data Prevista",
      "cancel": "Cancelar",
      "convert": "Converter em Negócio",
      "converting": "Convertendo..."
    },
    "activitiesModal": {
      "title": "Atividades",
      "noActivities": "Nenhuma atividade registrada",
      "noActivitiesHint": "Registre ligações, mensagens, anotações e próximos passos deste lead.",
      "createFirst": "Criar primeira atividade",
      "newBtn": "Nova",
      "newActivity": "Nova Atividade",
      "type": "Tipo",
      "subject": "Assunto",
      "subjectPlaceholder": "Ex: Ligação de follow-up",
      "description": "Descrição",
      "descriptionPlaceholder": "Detalhes da atividade...",
      "dateTime": "Data/Hora",
      "direction": "Direção",
      "directionOutbound": "Saída (você ligou/enviou)",
      "directionInbound": "Entrada (cliente ligou/enviou)",
      "cancel": "Cancelar",
      "create": "Criar",
      "result": "Resultado",
      "completedAt": "Concluída em",
      "reopen": "Reabrir",
      "complete": "Concluir",
      "delete": "Excluir"
    },
    "activityTypes": {
      "Call": "Ligação",
      "Meeting": "Reunião",
      "Task": "Tarefa",
      "WhatsApp": "WhatsApp",
      "Email": "Email",
      "Demo": "Demonstração",
      "FollowUp": "Follow-up",
      "Note": "Anotação"
    },
    "sources": {
      "Site": "Site",
      "Manual": "Manual",
      "Formulário": "Formulário",
      "WhatsApp": "WhatsApp",
      "Importação": "Importação",
      "Indicação": "Indicação"
    },
    "loadError": "Erro ao carregar leads. Tente novamente."
  },
  "inbox": {
    "title": "Inbox",
    "subtitle": "Central de conversas omnichannel",
    "boxLabel": "Caixa",
    "box": "Caixa",
    "boxAll": "todas",
    "boxInboxPrincipal": "Inbox principal",
    "searchPlaceholderLong": "Buscar conversa, nome ou número...",
    "tabAll": "Todas",
    "tabUnread": "Não lidas",
    "emptyNoChannelsTitle": "Seu inbox está pronto",
    "emptyNoChannelsDesc": "Conecte um canal para começar: Instagram, WhatsApp, Facebook, Telegram ou Webchat.",
    "emptyNoConversationsTitle": "Nenhuma conversa ainda",
    "emptyNoConversationsDesc": "Assim que alguém enviar mensagem, ela aparece aqui em tempo real.",
    "emptyNoConversationsChannel": "Nenhuma conversa do {{channel}} ainda.",
    "ctaViewChannels": "Ver canais",
    "ctaManageChannels": "Gerenciar canais",
    "ctaConnectChannel": "Conectar canal",
    "emptyChatTitle": "Selecione uma conversa",
    "emptyChatDescription": "As mensagens aparecerão aqui em tempo real.",
    "noMessagesYet": "Nenhuma mensagem ainda",
    "newMessagesCount": "{{count}} nova(s) mensagem(ns)",
    "goToBottom": "Ir para o fim",
    "resend": "Reenviar",
    "pickEmoji": "Escolha um emoji",
    "emojiRecent": "Recentes",
    "emojiSmileys": "Smileys e pessoas",
    "emojiGestures": "Gestos",
    "emojiHearts": "Corações",
    "emojiObjects": "Objetos",
    "emojiNature": "Natureza",
    "emojiFood": "Comida",
    "emojiNoRecent": "Nenhum emoji usado ainda",
    "attachComingSoon": "Anexos em breve",
    "conversationClosed": "Conversa fechada",
    "assignComingSoon": "Atribuição em breve",
    "moreActions": "Mais ações",
    "whatsapp": {
      "windowActiveUntil": "Janela ativa até {{date}}",
      "windowExpired": "Janela expirada",
      "windowExpiredUseTemplate": "Janela expirada. Envie um template para continuar.",
      "outsideWindowHint": "Fora da janela de 24h. Para falar com o contato, envie um Template Utility/Auth (custa 1 crédito).",
      "tabMessage": "Mensagem",
      "tabTemplate": "Template",
      "tabAttachment": "Anexo",
      "creditsLabel": "Créditos",
      "noCredits": "Saldo insuficiente. Compre créditos para enviar templates.",
      "lowCredits": "Saldo baixo. Compre mais créditos.",
      "buyCredits": "Comprar créditos",
      "selectTemplate": "Selecione um template",
      "templateCost": "Custo: 1 crédito",
      "templateSent": "Template enviado",
      "insufficientCreditsTitle": "Saldo insuficiente",
      "insufficientCreditsDesc": "Você precisa de créditos para enviar templates e abrir novas janelas."
    },
    "filterApplied": "Filtro: {{filter}}",
    "createLeadComingSoon": "Criar lead em breve",
    "createDealComingSoon": "Criar negócio em breve",
    "noInbox": "Nenhuma caixa",
    "configureChannels": "Configurar canais",
    "filters": "Filtros",
    "channel": "Canal",
    "all": "todos",
    "status": "Status",
    "statusAll": "todas",
    "statusNew": "nova",
    "statusInProgress": "em atendimento",
    "statusResolved": "resolvida",
    "responsible": "Responsável",
    "responsibleAll": "todos",
    "responsibleMe": "eu",
    "responsibleCompany": "usuários da empresa",
    "unreadOnly": "não lidas apenas",
    "mockState": "Mock estado:",
    "conversations": "Conversas",
    "searchPlaceholder": "Buscar conversa…",
    "unreadCount": "{{count}} não lidas",
    "noChannelsTitle": "Conecte seus canais para começar",
    "noChannelsDescription": "Ative Webchat, WhatsApp ou Instagram para receber mensagens aqui.",
    "noConversationsTitle": "Nenhuma conversa ainda",
    "noConversationsDescription": "Instale o Webchat no seu site ou conecte WhatsApp",
    "selectConversation": "Selecione uma conversa para começar",
    "viewDeal": "Ver deal",
    "createDeal": "Criar Negócio",
    "more": "Mais",
    "viewContact": "Ver contato",
    "createContact": "Criar contato",
    "viewLead": "Ver lead",
    "createLead": "Criar Lead",
    "crm": "CRM",
    "timeNow": "Agora",
    "timeMinutes": "{{count}} min",
    "noValue": "—",
    "channelNeedsReconnect": "Canal precisa reconectar.",
    "errorSending": "Erro ao enviar.",
    "assignResponsible": "Atribuir responsável",
    "markResolved": "Marcar como resolvida",
    "addTags": "Adicionar tags",
    "viewDetails": "Ver detalhes",
    "details": "Detalhes",
    "conversationStarted": "Conversa iniciada — aguarde a primeira mensagem",
    "today": "Hoje",
    "sending": "enviando…",
    "failedRetry": "falha · retry",
    "download": "Baixar",
    "image": "Imagem",
    "whatsapp24h": "Respeite a janela de 24h quando aplicável",
    "attach": "Anexar",
    "send": "Enviar",
    "couldNotLoad": "Não foi possível carregar conversas",
    "retry": "Recarregar",
    "threadNoIdFallback": "Thread sem id (aguardando ajuste do backend)",
    "threadNoIdFallbackHint": "Esta conversa ainda não possui id no servidor. Clique em Recarregar quando o backend estiver atualizado.",
    "modalMockMessage": "Modal mock — integração em fase posterior.",
    "close": "Fechar",
    "salesCopilotTitle": "Sales Copilot\nIA que resume conversas e sugere próximos passos.\nEm breve.",
    "channelWebchat": "Webchat",
    "channelWhatsapp": "WhatsApp",
    "channelInstagram": "Instagram",
    "channelMessenger": "Messenger",
    "channelTelegram": "Telegram",
    "channelLinkedin": "LinkedIn",
    "reply": "Responder…",
    "replyWhatsapp": "Responder via WhatsApp…",
    "replyInstagram": "Responder via Instagram…",
    "replyMessenger": "Responder via Messenger…",
    "replyTelegram": "Responder via Telegram…",
    "replyWebchat": "Responder via Webchat…",
    "replyLinkedin": "Responder via LinkedIn…",
    "tabInstagram": "Instagram",
    "tabWhatsApp": "WhatsApp",
    "emptySidebarTitle": "Seu inbox está pronto",
    "emptySidebarDescription": "Conecte um canal para começar: Instagram, WhatsApp, Facebook, Telegram ou Webchat.",
    "connectChannel": "Conectar canal",
    "assign": "Atribuir",
    "closeConversation": "Fechar conversa",
    "messagePlaceholder": "Digite sua mensagem...",
    "contact": "Contato",
    "info": "Informações",
    "firstContactAt": "Primeiro contato em",
    "lastMessageAt": "Última mensagem",
    "conversationStatus": "Status conversa",
    "statusOpen": "Aberta",
    "statusAssigned": "Atribuída",
    "statusClosed": "Fechada",
    "markAsRead": "Marcar como lida",
    "actions": "Ações",
    "inboxPrincipal": "Inbox Principal",
    "tabFacebook": "Facebook",
    "tabTelegram": "Telegram",
    "tabWebchat": "Webchat",
    "ctaAddChannel": "Adicionar canal",
    "ctaTestWebchat": "Testar Webchat",
    "channelConnected": "{{channel}} conectado",
    "channelDisconnected": "{{channel}} não conectado",
    "emoji": "Emoji",
    "mock": {
      "nameJoao": "João Santos",
      "nameMaria": "Maria Silva",
      "namePedro": "Pedro Lima",
      "nameCarla": "Carla Mendes",
      "nameAna": "Ana Costa",
      "nameRicardo": "Ricardo Alves",
      "lastThanks": "Obrigado pelo retorno!",
      "lastEnterprise": "Olá, gostaria de saber sobre o plano empresarial.",
      "lastCallWeek": "Podemos agendar uma call esta semana?",
      "lastDocument": "Enviei o documento no grupo.",
      "lastQuote": "Preciso de um orçamento urgente.",
      "lastPartnership": "Agradeço a oportunidade de parceria.",
      "yesterday": "Ontem",
      "tagVip": "VIP",
      "tagFollowUp": "Follow-up",
      "tagB2b": "B2B",
      "msgHelloPlan": "Olá, gostaria de saber sobre o plano empresarial.",
      "msgHelloSize": "Olá Maria! Claro, qual o tamanho da sua empresa?",
      "msgFifty": "Somos em torno de 50 pessoas.",
      "msgPhoto": "Segue uma foto do nosso escritório para vocês.",
      "msgGreatDoc": "Ótimo! Envio o documento com os benefícios.",
      "msgThanksReceived": "Obrigada! Já recebi.",
      "fileNameBenefits": "Beneficios-Plano-Empresarial.pdf"
    }
  },
  "pipeline": {
    "title": "Pipeline",
    "selectPipeline": "Selecione o pipeline",
    "favoritesLimitReached": "Você pode ter no máximo 3 favoritos.",
    "addFavorite": "Adicionar aos favoritos",
    "removeFavorite": "Remover dos favoritos",
    "removeFavoriteError": "Não foi possível remover dos favoritos. Tente novamente.",
    "defaultBadge": "Padrão",
    "setAsDefault": "Definir como padrão",
    "removeDefault": "Remover padrão",
    "searchPlaceholder": "Buscar negócios…",
    "newDeal": "Novo Negócio",
    "viewKanban": "Visualização Kanban",
    "viewList": "Visualização em Lista",
    "filterByStatus": "Filtrar negócios por status",
    "inPipeline": "no pipeline",
    "deals": "negócios",
    "winRate": "Taxa de ganho",
    "won": "ganhos",
    "lost": "perdidos",
    "closed": "Encerrados",
    "dealsCount": "{{count}} negócios",
    "dragDealHere": "Arraste um negócio para este estágio",
    "noClosedInFilter": "Nenhum negócio encerrado neste filtro",
    "wonBadge": "Ganho",
    "lostBadge": "Perdido",
    "allStages": "Todas as etapas",
    "allResponsibles": "Todos os responsáveis",
    "tableDeal": "Negócio",
    "tableCompany": "Empresa",
    "tableValue": "Valor",
    "tableStage": "Etapa",
    "tableResponsible": "Responsável",
    "tableLastActivity": "Última atividade",
    "tableCreatedAt": "Criado em",
    "tableActions": "Ações",
    "editDeal": "Editar negócio",
    "deleteDeal": "Excluir negócio",
    "edit": "Editar",
    "delete": "Excluir",
    "moveToStage": "Mover para outra fase",
    "noDealsFound": "Nenhum negócio encontrado",
    "adjustFilters": "Tente ajustar os filtros de busca",
    "paginatorTemplate": "Mostrando {first} a {last} de {totalRecords} negócios",
    "moveTo": "Mover para",
    "deleteModal": {
      "title": "Confirmar Exclusão",
      "message": "Tem certeza que deseja excluir o negócio",
      "permanent": "A exclusão é permanente.",
      "deleting": "Excluindo..."
    },
    "markAsLostModal": {
      "title": "Marcar como perdido",
      "dealLabel": "Negócio:",
      "selectReason": "Selecione o motivo da perda (da sua empresa):",
      "loadingReasons": "Carregando motivos...",
      "selectReasonPlaceholder": "Selecione o motivo",
      "saving": "Salvando..."
    },
    "statusFilter": {
      "title": "Status do Negócio",
      "inProgress": "Em andamento",
      "clear": "Limpar"
    },
    "drawer": {
      "newDeal": "Novo Negócio",
      "pipelineLabel": "Pipeline:",
      "stageLabel": "Etapa:",
      "dealTitle": "Título do Negócio",
      "companyOrLead": "Empresa ou Lead",
      "searchCompanyOrLead": "Buscar empresa ou lead...",
      "value": "Valor",
      "expectedCloseDate": "Data Prevista de Fechamento",
      "stage": "Etapa",
      "responsible": "Responsável",
      "cancel": "Cancelar",
      "createDeal": "Criar Negócio",
      "creating": "Criando…",
      "searching": "Buscando...",
      "noResults": "Nenhum resultado encontrado",
      "organization": "Empresa",
      "person": "Pessoa"
    },
    "drawerNewPipeline": {
      "titleNew": "Novo Pipeline",
      "titleEdit": "Editar Pipeline",
      "nameLabel": "Nome do Pipeline",
      "namePlaceholder": "Ex: Comercial Brasil – SaaS",
      "description": "Descrição",
      "descriptionPlaceholder": "Descreva o objetivo ou o tipo de negócios deste pipeline…",
      "useDefaultStages": "Usar etapas padrão",
      "stagesLabel": "Etapas do Pipeline",
      "customStages": "Etapas personalizadas",
      "customStagePlaceholder": "Nome da etapa personalizada",
      "addStage": "Adicionar etapa",
      "default": "Padrão",
      "cancel": "Cancelar",
      "createPipeline": "Criar Pipeline",
      "saveChanges": "Salvar Alterações",
      "creating": "Criando..."
    },
    "modal": {
      "stage": "Etapa",
      "selectStage": "Selecione uma etapa",
      "valueTotal": "Valor Total",
      "probability": "Probabilidade",
      "status": "Status",
      "summary": "Resumo",
      "addSummary": "Adicionar resumo",
      "mainInfo": "Informações principais",
      "dealDetails": "Detalhes do negócio",
      "customFields": "Campos personalizados",
      "manageFields": "Gerenciar campos",
      "noCustomFields": "Nenhum campo personalizado foi criado para este pipeline.",
      "createdAt": "Criado em",
      "closeIn": "Fecha em",
      "nextStageSuggested": "Próxima etapa sugerida:",
      "view": "Visualizar",
      "edit": "Editar",
      "delete": "Excluir",
      "close": "Fechar",
      "save": "Salvar",
      "saving": "Salvando...",
      "cancel": "Cancelar",
      "activities": "Atividades",
      "newActivity": "Nova Atividade",
      "noActivities": "Nenhuma atividade registrada",
      "noActivitiesHint": "Registre ligações, mensagens, anotações e próximos passos deste negócio.",
      "createFirstActivity": "Criar primeira atividade",
      "winDeal": "Ganhar Negócio",
      "loseDeal": "Perder Negócio",
      "backStage": "Voltar etapa",
      "nextStage": "Avançar etapa",
      "saveChanges": "Salvar Alterações",
      "call": "Ligar",
      "email": "Email",
      "whatsApp": "WhatsApp",
      "opening": "Abrindo...",
      "note": "Nota",
      "attachment": "Anexo",
      "noDescriptionYet": "Nenhuma descrição adicionada ainda.",
      "summaryPlaceholder": "Descreva brevemente o contexto atual deste negócio...",
      "titleLabel": "Título",
      "valueLabel": "Valor",
      "origin": "Origem",
      "selectOrigin": "Selecione uma origem",
      "expectedCloseDate": "Data Prevista de Fechamento",
      "dealInfoTab": "Informações do Negócio",
      "originTab": "Origem",
      "responsible": "Responsável",
      "relatedCompany": "Empresa relacionada",
      "noCompanyLinked": "Nenhuma empresa vinculada.",
      "relationshipContacts": "Relacionamento (Contatos)",
      "contacts": "Contatos",
      "noContactsLinked": "Nenhum contato vinculado.",
      "customFieldsTitle": "Campos personalizados",
      "attachments": "Anexos",
      "addFile": "Adicionar arquivo",
      "attach": "Anexar",
      "uploading": "Enviando...",
      "allowedFormats": "Formatos permitidos: PDF, DOC, DOCX, XLS, XLSX, CSV, TXT, RTF (máx. 5MB)",
      "loadingAttachments": "Carregando anexos...",
      "noAttachmentsYet": "Nenhum anexo adicionado ainda.",
      "deleteFile": "Excluir arquivo",
      "proposals": "Propostas",
      "newProposal": "Nova Proposta",
      "proposalApproved": "Proposta Aprovada",
      "proposalApprovedHint": "Este negócio possui uma proposta aprovada. As ações de criação, edição e reenvio de propostas estão bloqueadas.",
      "loadingProposals": "Carregando propostas...",
      "noProposalsYet": "Nenhuma proposta criada ainda.",
      "createdOn": "Criada em",
      "viewDetails": "Ver detalhes",
      "downloadPdf": "Baixar PDF",
      "sendByEmail": "Enviar por e-mail",
      "sendProposalDisabledRejected": "Não é possível enviar proposta rejeitada.",
      "sendProposalDisabledApproved": "Não é possível enviar. Já existe proposta aprovada.",
      "selectPlaceholder": "Selecione",
      "activityFormTitle": "Nova Atividade",
      "typeLabel": "Tipo",
      "textLabel": "Texto",
      "dateLabel": "Data",
      "timeLabel": "Hora",
      "channelLabel": "Canal",
      "descriptionOptional": "Descrição (opcional)",
      "followUpDescriptionPlaceholder": "Descrição do follow-up...",
      "taskTitlePlaceholder": "Ex: Preparar proposta comercial",
      "taskDueDateLabel": "Data de vencimento",
      "taskDescriptionPlaceholder": "Descrição da tarefa...",
      "meetingDescriptionPlaceholder": "Descrição da reunião...",
      "callDescriptionPlaceholder": "Registre detalhes da ligação...",
      "subjectLabel": "Assunto",
      "emailSubjectPlaceholder": "Assunto do email",
      "emailContentPlaceholder": "Conteúdo do email...",
      "templateLabel": "Template",
      "messageLabel": "Mensagem",
      "loadingTemplates": "Carregando...",
      "freeMessageOption": "Mensagem livre (sem template)",
      "messageEditablePlaceholder": "Mensagem (editável)...",
      "messagePlaceholder": "Digite sua mensagem para o cliente...",
      "previewAsClient": "Prévia (como o cliente verá):",
      "openWhatsApp": "Abrir WhatsApp",
      "fileLabel": "Arquivo",
      "createdBy": "Criado por",
      "userDefault": "Usuário",
      "notePlaceholder": "Anote pontos importantes da conversa, próximos passos ou observações...",
      "sendProposalTitle": "Enviar Proposta",
      "clientEmailLabel": "E-mail do Cliente",
      "clientEmailPlaceholder": "cliente@exemplo.com",
      "send": "Enviar",
      "customFieldsOrderTitle": "Ordenar campos personalizados",
      "customFieldsOrderDescription": "Ajuste a ordem e visibilidade dos campos personalizados deste pipeline.",
      "useArrowsHint": "Use os botões de seta para alterar a ordem dos campos.",
      "moveUp": "Mover para cima",
      "moveDown": "Mover para baixo",
      "noFieldsConfigured": "Nenhum campo personalizado configurado para este pipeline.",
      "callModalTitle": "Ligação",
      "callAutoRecordHint": "Ligação será registrada automaticamente no histórico",
      "phoneLabel": "Telefone",
      "phonePlaceholder": "(00) 00000-0000",
      "startCall": "Iniciar ligação",
      "callInProgress": "Ligação em andamento...",
      "endCall": "Encerrar",
      "resultLabel": "Resultado",
      "resultAnswered": "Atendeu",
      "resultNoAnswer": "Não atendeu",
      "resultVoicemail": "Caixa postal",
      "resultBusy": "Ocupado",
      "observationLabel": "Observação",
      "observationPlaceholder": "Adicione observações sobre a ligação...",
      "durationLabel": "Duração:",
      "emailModalTitle": "Enviar Email",
      "toLabel": "Para",
      "toPlaceholder": "destinatario@exemplo.com",
      "aiHelpLabel": "✨ Ajuda para escrever",
      "themeOptionalLabel": "Tema (opcional)",
      "themePlaceholder": "Ex: Apresentação de produto X",
      "generateText": "Gerar texto",
      "generating": "Gerando...",
      "replaceConfirmTitle": "Substituir mensagem atual?",
      "replace": "Substituir",
      "append": "Anexar ao final",
      "suggestedText": "✨ Texto sugerido",
      "generateAgain": "Gerar novamente",
      "messagePlaceholderEmail": "Digite sua mensagem...",
      "noteModalTitle": "Nova Nota",
      "attachmentModalTitle": "Anexar Arquivo",
      "selectedFileLabel": "Arquivo selecionado:",
      "proposalStatusDraft": "Rascunho",
      "proposalStatusSent": "Enviada",
      "proposalStatusViewed": "Visualizada",
      "proposalStatusApproved": "Aprovada",
      "proposalStatusRejected": "Rejeitada",
      "proposalStatusExpired": "Expirada",
      "statusOpen": "Aberto",
      "statusWon": "Ganho",
      "statusLost": "Perdido",
      "channelCall": "Ligação",
      "channelEmail": "Email",
      "channelWhatsApp": "WhatsApp",
      "manualSuffix": "(Manual)",
      "digitePlaceholder": "Digite ",
      "activityTypeNote": "Nota",
      "activityTypeFollowUp": "Follow-up",
      "activityTypeTask": "Tarefa",
      "activityTypeMeeting": "Reunião",
      "activityTypeCallManual": "Ligação (Manual)",
      "activityTypeEmailManual": "Email (Manual)",
      "activityTypeWhatsAppManual": "WhatsApp (Manual)",
      "activityTypeAttachmentManual": "Anexo (Manual)",
      "optional": "opcional",
      "activityDefault": "Atividade"
    }
  },
  "proposals": {
    "newDrawer": {
      "titleNew": "Nova Proposta",
      "titleEdit": "Editar Proposta",
      "linkedTo": "Proposta vinculada a",
      "selectDeal": "Selecione um negócio",
      "clientAutoHint": "Cliente será preenchido automaticamente com o Cliente do negócio",
      "titleLabel": "Título",
      "titlePlaceholder": "Digite o título da proposta",
      "templateLabel": "Modelo da Proposta",
      "loadingTemplates": "Carregando modelos...",
      "itemsLabel": "Itens da Proposta",
      "addItem": "Adicionar Item",
      "noItemsHint": "Nenhum item adicionado. Clique em 'Adicionar Item' para começar.",
      "product": "Produto",
      "qty": "Qtd",
      "unitPrice": "Unitário",
      "total": "Total",
      "select": "Selecione",
      "removeItem": "Remover item",
      "withinRange": "Dentro da faixa",
      "outOfRange": "Fora da faixa",
      "adjustmentsRecorded": "Ajustes registrados",
      "pricingReasonLabel": "Motivo do ajuste",
      "pricingReasonPlaceholder": "Explique o motivo do ajuste de preço...",
      "totalLabel": "Total:",
      "valueLabel": "Valor da Proposta",
      "autoCalculateLabel": "Gerar valor automaticamente pelos itens",
      "validUntilLabel": "Validade da Proposta",
      "internalNotesLabel": "Observações internas",
      "internalNotesPlaceholder": "Adicione observações internas sobre esta proposta...",
      "attachmentsLabel": "Arquivos anexos",
      "attach": "Anexar",
      "uploading": "Enviando...",
      "allowedFormats": "Formatos permitidos: PDF, DOC, DOCX, XLS, XLSX, CSV, TXT, RTF, imagens (máx. 10MB)",
      "selectedFiles": "Arquivos selecionados:",
      "removeFile": "Remover arquivo",
      "loadingAttachments": "Carregando anexos...",
      "noAttachmentsYet": "Nenhum anexo adicionado ainda.",
      "deleteFile": "Excluir arquivo",
      "cancel": "Cancelar",
      "saving": "Salvando...",
      "saveChanges": "Salvar Alterações",
      "createProposal": "Criar Proposta"
    }
  },
  "pipelines": {
    "title": "Pipelines",
    "subtitle": "Gerencie os pipelines de vendas da sua empresa",
    "registerPipeline": "Cadastrar Pipeline",
    "searchPlaceholder": "Buscar pipelines...",
    "search": "Buscar",
    "loading": "Carregando pipelines...",
    "emptyTitle": "Nenhum pipeline encontrado",
    "emptyWithFilters": "Tente ajustar os filtros de busca",
    "emptyNoFilters": "Comece criando seu primeiro pipeline",
    "tableName": "Nome",
    "tableStages": "Etapas",
    "tableDeals": "Negócios",
    "tableStatus": "Status",
    "tableActions": "Ações",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "editPipeline": "Editar pipeline",
    "copyPipeline": "Copiar pipeline",
    "deletePipeline": "Excluir pipeline",
    "paginatorReport": "Mostrando {first} a {last} de {totalRecords} pipelines",
    "deleteModal": {
      "title": "Excluir Pipeline",
      "message": "Tem certeza que deseja excluir o pipeline",
      "warning": "Esta ação não pode ser desfeita.",
      "cancel": "Cancelar",
      "delete": "Excluir",
      "deleting": "Excluindo..."
    },
    "copyModal": {
      "title": "Duplicar Pipeline",
      "message": "Informe um nome para o pipeline copiado. O sistema garantirá automaticamente que o nome seja único.",
      "nameLabel": "Nome do Pipeline",
      "namePlaceholder": "Nome do pipeline copiado",
      "cancel": "Cancelar",
      "duplicate": "Duplicar"
    },
    "drawer": {
      "titleNew": "Novo Pipeline",
      "titleEdit": "Editar Pipeline",
      "subtitle": "Configure o pipeline de vendas",
      "nameLabel": "Nome do Pipeline",
      "namePlaceholder": "Ex.: Pipeline Principal",
      "description": "Descrição",
      "descriptionPlaceholder": "Descrição do pipeline (opcional)",
      "active": "Ativo",
      "restrictByRole": "Restringir acesso por Role",
      "restrictByRoleHint": "Selecione as roles que podem ver este pipeline. Se nenhuma for selecionada, todos os usuários poderão ver.",
      "loadingRoles": "Carregando roles...",
      "noRoles": "Nenhuma role disponível.",
      "rolesSelected": "{{count}} role(s) selecionada(s)",
      "stages": "Etapas",
      "stagesDefaultEditable": "Etapas (Padrão Editáveis)",
      "add": "Adicionar",
      "noStagesHint": "Nenhuma etapa adicionada. Clique em \"Adicionar\" para criar etapas.",
      "cannotDeleteStagesWarning": "⚠️ Atenção: Este pipeline possui negociações associadas. Não é possível deletar etapas, mas você pode adicionar novas etapas, editar nomes e probabilidades.",
      "stageNamePlaceholder": "Nome da etapa",
      "defaultStageQualification": "Qualificação",
      "defaultStageProposal": "Proposta",
      "defaultStageNegotiation": "Negociação",
      "defaultStageClosing": "Fechamento",
      "moveUp": "Mover para cima",
      "moveDown": "Mover para baixo",
      "removeStage": "Remover etapa",
      "cannotRemoveStageTitle": "Não é possível remover etapas quando o pipeline possui negociações associadas",
      "cancel": "Cancelar",
      "saveChanges": "Salvar Alterações",
      "register": "Cadastrar",
      "saving": "Salvando...",
      "nameRequired": "Nome do pipeline é obrigatório.",
      "stagesMinOne": "Adicione pelo menos uma etapa.",
      "stagesAllMustHaveName": "Todas as etapas devem ter um nome."
    }
  },
  "lostReasons": {
    "title": "Motivos de Perda",
    "subtitle": "Configure os motivos exibidos quando um negócio é marcado como \"Perdido\".",
    "registerReason": "Cadastrar Motivo",
    "searchPlaceholder": "Buscar motivos...",
    "search": "Buscar",
    "loading": "Carregando motivos de perda...",
    "emptyTitle": "Nenhum motivo de perda encontrado",
    "emptyWithFilters": "Tente ajustar os filtros de busca",
    "emptyNoFilters": "Comece criando seu primeiro motivo de perda",
    "tableName": "Nome",
    "tableDescription": "Descrição",
    "tableCategory": "Categoria",
    "tableActions": "Ações",
    "editReason": "Editar motivo",
    "deleteReason": "Excluir motivo",
    "paginatorReport": "Mostrando {first} a {last} de {totalRecords} motivos",
    "deleteModal": {
      "title": "Excluir Motivo de Perda",
      "message": "Tem certeza que deseja excluir o motivo",
      "warning": "Esta ação não pode ser desfeita.",
      "cancel": "Cancelar",
      "delete": "Excluir",
      "deleting": "Excluindo..."
    },
    "drawer": {
      "titleNew": "Cadastrar Motivo de Perda",
      "titleEdit": "Editar Motivo",
      "subtitle": "Configure o motivo de perda",
      "nameLabel": "Nome do Motivo",
      "namePlaceholder": "Ex.: Preço muito alto",
      "category": "Categoria",
      "description": "Descrição",
      "descriptionPlaceholder": "Descrição detalhada do motivo de perda (opcional)",
      "cancel": "Cancelar",
      "saveChanges": "Salvar Alterações",
      "register": "Cadastrar",
      "saving": "Salvando..."
    },
    "categories": {
      "Price": "Preço",
      "Competition": "Concorrência",
      "Timing": "Timing",
      "Fit": "Adequação",
      "Internal": "Interno",
      "Other": "Outros"
    }
  },
  "marketing": {
    "tags": {
      "title": "Tags",
      "subtitle": "Organize contatos, empresas e negócios para segmentar campanhas.",
      "newTag": "Nova tag",
      "searchPlaceholder": "Buscar tag…",
      "filterAll": "Todos",
      "filterActive": "Ativas",
      "filterInactive": "Inativas",
      "tableTag": "Tag",
      "tableDescription": "Descrição",
      "tableUsage": "Uso",
      "tableStatus": "Status",
      "tableActions": "Ações",
      "paginatorReport": "Mostrando {first} a {last} de {totalRecords} tags",
      "statusActive": "Ativa",
      "statusInactive": "Inativa",
      "edit": "Editar",
      "viewUsage": "Ver uso",
      "deactivate": "Desativar",
      "activate": "Ativar",
      "emptyTitle": "Nenhuma tag criada ainda",
      "emptyWithFilters": "Ajuste os filtros para ver resultados.",
      "emptyNoFilters": "Crie tags para organizar contatos, empresas e negócios.",
      "tooltipEdit": "Editar tag",
      "tooltipViewUsage": "Ver uso da tag",
      "tooltipDeactivate": "Desativar tag",
      "tooltipActivate": "Ativar tag",
      "tooltipCreateSegment": "Criar segmento com esta tag",
      "usageTooltipDetail": "Usada em:\n• Pessoas: {{people}}\n• Empresas: {{organizations}}\n• Negócios: {{deals}}",
      "usageTooltipNone": "Esta tag ainda não está sendo usada.",
      "modalPreview": "Preview",
      "modalNameMax": "máx 40 caracteres",
      "modalDescMax": "máx 300 caracteres",
      "tableCreatedAt": "Criado em",
      "modalCreateTitle": "Nova tag",
      "modalEditTitle": "Editar tag",
      "modalSubtitle": "Nome, cor e descrição para identificar a tag nas listas.",
      "modalFooterHint": "Você pode alterar isso depois.",
      "modalCreateButton": "Criar tag",
      "modalName": "Nome",
      "modalNamePlaceholder": "Ex.: Cliente VIP",
      "modalNameHelper": "Este nome aparece nas listas e ao segmentar campanhas.",
      "modalColor": "Cor",
      "modalColorDefault": "Padrão",
      "modalDescription": "Descrição",
      "modalDescriptionPlaceholder": "Descrição (opcional)",
      "modalPreviewDefaultName": "CLIENTE VIP",
      "usageTitle": "Uso da tag",
      "usagePeople": "Pessoas",
      "usageOrganizations": "Empresas",
      "usageDeals": "Negócios",
      "createSegmentFromTag": "Criar segmento com esta tag",
      "closeUsageModal": "Fechar modal de uso da tag",
      "loading": "Carregando…",
      "tryAgain": "Tentar novamente",
      "nameRequired": "Nome é obrigatório.",
      "tagCreated": "Tag criada.",
      "tagUpdated": "Tag atualizada.",
      "tagActivated": "Tag ativada.",
      "tagDeactivated": "Tag desativada.",
      "statusChangeError": "Não foi possível alterar o status.",
      "errorDuplicate": "Já existe uma tag com esse nome.",
      "errorSave": "Erro ao salvar. Tente novamente.",
      "confirmModal": {
        "titleDeactivate": "Desativar tag?",
        "messageDeactivate": "A tag \"{{name}}\" deixará de estar disponível para uso em segmentos e campanhas. Você pode ativá-la novamente depois.",
        "titleActivate": "Ativar tag?",
        "messageActivate": "A tag \"{{name}}\" voltará a ficar disponível para uso em segmentos e campanhas.",
        "cancel": "Cancelar",
        "deactivate": "Desativar",
        "activate": "Ativar",
        "processing": "Processando…"
      }
    },
    "segments": {
      "title": "Segmentos",
      "subtitle": "Crie listas inteligentes para disparos por email.",
      "newSegment": "Novo segmento",
      "searchPlaceholder": "Buscar…",
      "filterType": "Tipo",
      "selectTypePlaceholder": "Selecione um tipo para segmentar",
      "typePeople": "Pessoas",
      "typeOrganizations": "Empresas",
      "typeDeals": "Negócios",
      "filterActive": "Ativos",
      "filterInactive": "Inativos",
      "statusActive": "Ativo",
      "statusInactive": "Inativo",
      "tableName": "Nome",
      "tableType": "Tipo",
      "tableEstimate": "Estimativa",
      "tableStatus": "Status",
      "tableActions": "Ações",
      "updatedAt": "Atualizado em",
      "edit": "Editar",
      "duplicate": "Duplicar",
      "createCampaign": "Criar campanha",
      "emptyTitle": "Nenhum segmento encontrado",
      "emptyNoFilters": "Crie seu primeiro segmento para disparar campanhas por email.",
      "estimate": "Estimativa",
      "destinations": "destinatários",
      "paginatorReport": "Mostrando {first} a {last} de {totalRecords} segmentos",
      "estimateNow": "Estimar agora",
      "saveSegment": "Salvar segmento",
      "back": "Voltar",
      "nameRequired": "Nome é obrigatório.",
      "saved": "Segmento salvo.",
      "created": "Segmento criado.",
      "includeAny": "Incluir (qualquer uma)",
      "includeAll": "Incluir (todas)",
      "exclude": "Excluir",
      "onlyValidEmail": "Somente com email válido",
      "segmentName": "Nome do segmento",
      "segmentNameRequired": "Nome do segmento é obrigatório.",
      "segmentTypeRequired": "Selecione um tipo para segmentar.",
      "segmentNamePlaceholder": "Ex.: Leads Feira 2026",
      "segmentNameMax": "máx 60 caracteres",
      "modalTitleNew": "Novo segmento",
      "modalTitleEdit": "Editar segmento",
      "modalSubtitle": "Crie listas inteligentes para disparos por email.",
      "configAndRules": "Configuração e Regras",
      "configSegmentTitle": "Configuração do segmento",
      "preview": "Prévia",
      "previewClickEstimate": "Clique em \"Estimar agora\" para ver a estimativa.",
      "previewInitial": "A prévia será atualizada automaticamente conforme você define as regras.",
      "previewEstimating": "Calculando estimativa…",
      "previewEstimateLabel": "Estimativa",
      "previewEstimateHint": "A estimativa considera as regras do segmento. Contatos descadastrados serão filtrados no envio.",
      "previewError": "Não foi possível calcular a estimativa. Tente novamente.",
      "previewTooLarge": "Segmento muito amplo. Refine as regras para ficar dentro do limite por campanha.",
      "onlyValidEmailTooltip": "Recomendado para campanhas de email.",
      "onlyValidEmailDisabledHint": "Disponível apenas para segmentos de Pessoas ou Empresas.",
      "tagsBlockLabel": "Tags",
      "tagsBlockIntro": "Use tags para definir quais registros devem entrar ou ser excluídos deste segmento.",
      "filtersSectionLabel": "Filtros",
      "filtersSectionIntro": "Defina quais registros entram ou são excluídos deste segmento.",
      "includeRegistersTitle": "Incluir registros",
      "includeRegistersSubtitle": "Contatos que tenham qualquer destas tags",
      "includeRegistersHint": "Contatos que possuam qualquer uma destas tags.",
      "excludeRegistersTitle": "Excluir registros",
      "excludeRegistersSubtitle": "Contatos que tenham estas tags",
      "excludeRegistersHint": "Contatos que possuam estas tags serão removidos do segmento.",
      "optionsSectionLabel": "Opções",
      "registros": "registros",
      "previewSubtitlePeople": "Pessoas que correspondem às regras definidas.",
      "previewSubtitleOrgs": "Empresas que correspondem às regras definidas.",
      "previewSubtitleDeals": "Negócios que correspondem às regras definidas.",
      "previewSubtitleAuto": "Atualizado automaticamente",
      "previewZero": "Nenhum contato corresponde às regras atuais.",
      "includeTagsLabel": "Incluir contatos que tenham estas tags",
      "includeTagsHint": "(qualquer uma destas tags)",
      "includeTagsTooltip": "Contatos que tenham qualquer uma destas tags entrarão no segmento.",
      "excludeTagsLabel": "Excluir contatos que tenham estas tags",
      "excludeTagsTooltip": "Contatos com essas tags serão removidos do segmento.",
      "addTag": "Adicionar tag",
      "addTagPlaceholder": "+ adicionar tag",
      "searchTagPlaceholder": "Buscar tag…",
      "noTagsInList": "Nenhuma tag encontrada.",
      "removeTag": "Remover tag",
      "closeModal": "Fechar modal",
      "discardConfirmTitle": "Descartar alterações?",
      "discardConfirmMessage": "Há alterações não salvas. Deseja descartar?",
      "discardConfirmCancel": "Continuar editando",
      "discardConfirmDiscard": "Descartar",
      "activate": "Ativar",
      "deactivate": "Desativar",
      "segmentSaved": "Segmento salvo.",
      "segmentDuplicated": "Segmento duplicado.",
      "duplicateError": "Erro ao duplicar.",
      "segmentActivated": "Segmento ativado.",
      "segmentDeactivated": "Segmento desativado.",
      "statusChangeError": "Não foi possível alterar o status.",
      "loading": "Carregando…",
      "tryAgain": "Tentar novamente"
    },
    "templates": {
      "title": "Templates",
      "subtitle": "Crie mensagens reutilizáveis para campanhas.",
      "newTemplate": "Novo template",
      "searchPlaceholder": "Buscar por nome…",
      "filterActive": "Ativos",
      "filterInactive": "Inativos",
      "filterAll": "Todos",
      "cardSubject": "Assunto",
      "lastUpdate": "Última atualização",
      "edit": "Editar",
      "duplicate": "Duplicar",
      "preview": "Preview",
      "test": "Teste",
      "emptyTitle": "Nenhum template encontrado",
      "emptyNoFilters": "Crie um template para agilizar suas campanhas.",
      "emptyWithFilters": "Nenhum resultado com os filtros aplicados.",
      "save": "Salvar",
      "sendTest": "Enviar teste",
      "variables": "Variáveis",
      "copyVariable": "Copiar",
      "loading": "Carregando…",
      "tryAgain": "Tentar novamente",
      "tableType": "Tipo",
      "tableName": "Nome",
      "tablePreview": "Prévia",
      "tableStatus": "Status",
      "tableActions": "Ações",
      "typeEmail": "Email",
      "typeWhatsapp": "WhatsApp",
      "whatsappEditHint": "Templates WhatsApp são editados em Configurações.",
      "whatsappDuplicateHint": "Duplicar template WhatsApp em breve.",
      "whatsappToggleHint": "Ativar/desativar template WhatsApp em breve.",
      "statusActive": "Ativo",
      "statusInactive": "Inativo",
      "paginatorReport": "Mostrando {first} a {last} de {totalRecords} templates",
      "createModalTitle": "Criar template",
      "createModalSubtitle": "Defina o nome e a base do template.",
      "createChannelTitle": "Crie uma campanha única do zero.",
      "channelEmail": "E-mail",
      "channelSms": "SMS",
      "channelWhatsapp": "WhatsApp",
      "channelPush": "Push",
      "channelComingSoon": "Em breve",
      "channelLabel": "Canal",
      "baseLabel": "Base",
      "createStep1Title": "Configuração",
      "createStep2Title": "Base do template",
      "createReviewTitle": "Revisão",
      "namePlaceholder": "Ex.: Boas-vindas, Newsletter",
      "startBlank": "Começar em branco",
      "useModel": "Usar modelo",
      "blankTemplateInfo": "Você criará um template em branco e poderá editar no próximo passo.",
      "createButton": "Criar",
      "continue": "Continuar",
      "back": "Voltar",
      "closeCreateModal": "Fechar modal de criação de template",
      "templateNameRequired": "Nome do template é obrigatório.",
      "templateCreated": "Template criado.",
      "templateServiceUnavailable": "Serviço de templates não disponível. Verifique se o backend está configurado (POST /api/marketing/templates).",
      "templateCreateError": "Erro ao criar template. Tente novamente.",
      "templateDuplicated": "Template duplicado.",
      "duplicateError": "Erro ao duplicar.",
      "templateActivated": "Template ativado.",
      "templateDeactivated": "Template desativado.",
      "statusChangeError": "Não foi possível alterar o status.",
      "blockHeader": "Cabeçalho",
      "blockText": "Texto",
      "blockButton": "Botão",
      "blockImage": "Imagem",
      "blockDivider": "Divisor",
      "blockFooter": "Rodapé",
      "blockDescHeader": "Título + subtítulo",
      "blockDescText": "Parágrafo / lista",
      "blockDescButton": "CTA",
      "blockDescImage": "Banner",
      "blockDescDivider": "Separador",
      "blockDescFooter": "Contato + links",
      "blocksTitle": "Blocos",
      "blocksIntro": "Clique para adicionar ao final.",
      "searchBlock": "Buscar bloco…",
      "quickSuggestions": "Sugestões rápidas",
      "modelBoasVindas": "Boas-vindas",
      "modelFollowUp": "Follow-up",
      "modelNewsletter": "Newsletter simples",
      "modelPromo": "Promo simples",
      "modelAtualizacaoProduto": "Atualização de produto",
      "modelConfirmacao": "Confirmação",
      "emptyCanvasTitle": "Comece seu template",
      "emptyCanvasText": "Escolha um bloco à esquerda ou use um modelo pronto.",
      "addHeader": "Adicionar cabeçalho",
      "addText": "Adicionar texto",
      "templateEditorTitle": "Template",
      "statusDraft": "Rascunho",
      "checklistTitle": "Checklist de qualidade",
      "checklistFooter": "Tem rodapé",
      "checklistCta": "Tem botão/CTA",
      "checklistLinks": "Links válidos",
      "checklistAlt": "Imagens com alt text",
      "templateSettings": "Configurações do template",
      "widthDesktop": "Desktop",
      "widthMobile": "Mobile",
      "propertiesHint": "Dica: clique em um bloco no canvas para editar conteúdo e estilo.",
      "duplicateBlock": "Duplicar bloco",
      "moveUp": "Mover para cima",
      "moveDown": "Mover para baixo",
      "removeBlock": "Remover",
      "previewSubject": "Assunto",
      "previewPreheader": "Pré-cabeçalho",
      "canvasTitle": "Canvas",
      "propertiesTitle": "Propriedades",
      "visualMode": "Visual",
      "htmlMode": "HTML",
      "previewTitle": "Prévia",
      "previewDesktop": "Desktop",
      "previewMobile": "Mobile",
      "sendTestTitle": "Enviar teste",
      "sendTestEmail": "Email destino",
      "sendTestButton": "Enviar"
    },
    "campaigns": {
      "title": "Campanhas de email",
      "subtitle": "Envie campanhas segmentadas para seus contatos.",
      "newCampaign": "Nova campanha",
      "searchPlaceholder": "Buscar…",
      "search": "Buscar",
      "filterStatus": "Status",
      "statusDraft": "Rascunho",
      "statusScheduled": "Agendada",
      "statusRunning": "Enviando",
      "statusPaused": "Pausada",
      "statusCompleted": "Enviada",
      "statusCancelled": "Cancelada",
      "statusFailed": "Falhou",
      "tableName": "Nome",
      "tableStatus": "Status",
      "tableSegment": "Segmento",
      "tableTemplate": "Template",
      "tableSchedule": "Agendamento",
      "tableProgress": "Progresso",
      "tableSent": "Enviados",
      "tableEnvios": "Envios",
      "tableCreatedAt": "Criado em",
      "tableActions": "Ações",
      "listRecipients": "Destinatários",
      "listOpens": "Aberturas",
      "listClicks": "Cliques",
      "listUnsubscribed": "Inscrição cancelada",
      "listSent": "Enviados",
      "listFailed": "Falhas",
      "listSkipped": "Ignorados",
      "listSentAt": "Enviada em",
      "listStartedAt": "Iniciada em",
      "listScheduledAt": "Agendada para",
      "tableFailed": "Falhas",
      "tableSkipped": "Ignorados",
      "emptyTitle": "Nenhuma campanha encontrada",
      "emptyNoFilters": "Crie sua primeira campanha.",
      "paginatorReport": "Mostrando {first} a {last} de {totalRecords} campanhas",
      "loading": "Carregando…",
      "tryAgain": "Tentar novamente",
      "edit": "Editar",
      "duplicate": "Duplicar",
      "viewReport": "Ver relatório",
      "archive": "Arquivar",
      "wizardTitle": "Criar campanha",
      "wizardSubtitle": "Configure e envie sua campanha de email.",
      "step1Title": "Configuração da campanha",
      "step2Title": "Escolha o público",
      "step3Title": "Escolha o template de email",
      "step4Title": "Revisão e envio",
      "campaignName": "Nome da campanha",
      "emailSubject": "Assunto do email",
      "preheader": "Preheader (opcional)",
      "preheaderHint": "Aparece após o assunto na caixa de entrada.",
      "senderName": "Nome do remetente",
      "senderEmail": "Email do remetente",
      "senderBlockTitle": "Remetente",
      "loadingSender": "Carregando remetente…",
      "senderConfiguredHint": "Este email está configurado nas configurações de envio da sua empresa.",
      "senderDefaultHint": "Você está usando o envio padrão do Pipeup. Recomendamos configurar seu domínio para melhorar entregabilidade.",
      "senderChangeConfig": "Alterar configuração",
      "senderConfigureSmtp": "Configurar SMTP",
      "closeWizard": "Fechar assistente de campanha",
      "senderNamePlaceholder": "Ex.: Ricardo – Pipeup",
      "senderNameHint": "Altera apenas o nome exibido. O email real é o configurado no sistema.",
      "deliveryLimitsTitle": "Limite de envio padrão",
      "deliveryLimitsLoading": "Carregando limites de envio...",
      "deliveryLimitsError": "Não foi possível carregar os limites de envio.",
      "deliveryLimitsEmpty": "Limites de envio não configurados. O sistema usará valores padrão.",
      "deliveryLimitsMaxPerCampaign": "Máximo por campanha",
      "deliveryLimitsRateSummary": "{{perMinute}}/min • {{perHour}}/hora • {{perDay}}/dia",
      "deliveryLimitsNoRestriction": "Horários de envio: sem restrição",
      "deliveryLimitsAllowedHours": "Horários permitidos",
      "deliveryLimitsFooter": "Os envios respeitam automaticamente esses limites e podem entrar em fila.",
      "deliverabilityTips": "Dica de entregabilidade",
      "tip1": "Use assuntos claros e naturais",
      "tip2": "Evite excesso de CAPS ou emojis",
      "tip3": "Não use palavras como \"GRÁTIS!!!\" ou \"URGENTE\"",
      "segmentSelect": "Segmento",
      "selectPlaceholder": "Selecione...",
      "segmentPreview": "Prévia",
      "segmentOptionContacts": "{{count}} contatos",
      "segmentCount": "{{count}} contatos",
      "segmentPreviewHint": "Contatos que correspondem às regras do segmento.",
      "segmentPreviewAuto": "Atualizado automaticamente",
      "segmentEmpty": "Nenhum contato corresponde a este segmento.",
      "preview": "Preview",
      "selectTemplate": "Selecionar template",
      "createNewTemplate": "Criar novo template",
      "reviewSummary": "Resumo da campanha",
      "reviewName": "Nome",
      "reviewSubject": "Assunto",
      "reviewSegment": "Segmento",
      "reviewEstimatedCount": "Quantidade estimada",
      "reviewTemplate": "Template",
      "bestPractices": "Boas práticas de entregabilidade",
      "bp1": "Evite enviar para contatos sem consentimento",
      "bp2": "Use segmentos atualizados",
      "bp3": "Não envie muitos emails em sequência",
      "sendNow": "Enviar agora",
      "scheduleSend": "Agendar envio",
      "scheduleAt": "Data e hora",
      "copySuffix": "cópia",
      "continue": "Continuar",
      "sendCampaign": "Enviar campanha",
      "back": "Voltar",
      "wizardStepBasic": "Básico",
      "wizardStepSegment": "Segmento",
      "wizardStepTemplate": "Template",
      "wizardStepSend": "Envio",
      "wizardBasicData": "Dados básicos",
      "wizardChannel": "Canal",
      "wizardChannelEmailMvp": "Email (MVP)",
      "wizardReplyTo": "Reply-To",
      "wizardSelectSegment": "Selecione o segmento",
      "wizardRecipientsCount": "{{count}} destinatários",
      "wizardSelectTemplate": "Selecione o template",
      "wizardSendTitle": "Envio",
      "wizardSchedule": "Agendar",
      "wizardUnsubscribedHint": "Contatos descadastrados serão ignorados automaticamente.",
      "wizardNext": "Próximo",
      "wizardCreateAnd": "Criar e",
      "wizardStart": "iniciar",
      "wizardScheduleVerb": "agendar",
      "errorFillNameAndSubject": "Preencha nome e assunto.",
      "errorSelectSegment": "Selecione um segmento.",
      "errorSelectTemplate": "Selecione um template.",
      "errorFillRequiredFields": "Preencha todos os campos obrigatórios.",
      "errorCreatedWithoutId": "Campanha criada mas ID não retornado. Tente abrir a campanha e iniciar manualmente.",
      "successCreated": "Campanha criada.",
      "successCreatedAndStarted": "Campanha criada e envio iniciado.",
      "errorCreatedButStartFailed": "Campanha criada, mas falha ao iniciar envio. Tente iniciar pela tela da campanha.",
      "successCreatedAndScheduled": "Campanha criada e agendada.",
      "errorCreateCampaign": "Erro ao criar campanha.",
      "successArchived": "Campanha arquivada.",
      "errorArchive": "Erro ao arquivar.",
      "detailStartedAt": "Iniciada em",
      "detailPause": "Pausar",
      "detailResume": "Retomar",
      "cancelCampaign": "Cancelar campanha",
      "detailProgressOf": "de",
      "detailEmailsSent": "emails enviados",
      "detailTotalRecipients": "Total destinatários",
      "detailOpens": "Aberturas",
      "detailClicks": "Cliques",
      "detailUnsubscribed": "Inscrição cancelada",
      "detailSent": "Enviados",
      "detailFailed": "Falhas",
      "detailSkipped": "Ignorados",
      "detailDetails": "Detalhes da campanha",
      "detailSegment": "Segmento",
      "detailTemplate": "Template",
      "detailSchedule": "Agendamento",
      "detailStartDate": "Data de início",
      "detailPreview": "Preview do email",
      "detailShowPreview": "Ver preview",
      "detailHidePreview": "Ocultar preview",
      "detailActivity": "Atividade",
      "detailNoEvents": "Nenhum evento ainda.",
      "detailNoTemplateContent": "Nenhum conteúdo do template.",
      "detailEventSent": "Email enviado",
      "detailEventFailed": "Falha de envio",
      "detailEventSkipped": "Ignorado",
      "detailCompletedTitle": "Campanha concluída",
      "detailCompletedSummary": "Resumo final",
      "detailViewReport": "Ver relatório",
      "detailDuplicateCampaign": "Duplicar campanha",
      "detailPaused": "Campanha pausada.",
      "detailPauseError": "Erro ao pausar.",
      "detailResumed": "Campanha retomada.",
      "detailResumeError": "Erro ao retomar.",
      "detailCancelled": "Campanha cancelada.",
      "detailCancelError": "Erro ao cancelar."
    }
  },
  "customFields": {
    "title": "Campos Personalizados",
    "subtitle": "Configure campos adicionais para negócios, empresas, pessoas e produtos.",
    "registerField": "Cadastrar Campo",
    "searchPlaceholder": "Buscar campos...",
    "allEntities": "Todas as Entidades",
    "search": "Buscar",
    "loading": "Carregando campos personalizados...",
    "emptyTitle": "Nenhum campo personalizado encontrado",
    "emptyWithFilters": "Tente ajustar os filtros de busca",
    "emptyNoFilters": "Comece criando seu primeiro campo personalizado",
    "tableField": "Campo",
    "tableEntity": "Entidade",
    "tableDataType": "Tipo de Dado",
    "tableOptions": "Opções",
    "tableRequired": "Obrigatório",
    "tableFilterable": "Filtrável",
    "tableActions": "Ações",
    "editField": "Editar campo",
    "deleteField": "Excluir campo",
    "paginatorReport": "Mostrando {first} a {last} de {totalRecords} campos",
    "deleteModal": {
      "title": "Excluir Campo Personalizado",
      "message": "Tem certeza que deseja excluir o campo",
      "warning": "Esta ação não pode ser desfeita.",
      "cancel": "Cancelar",
      "delete": "Excluir",
      "deleting": "Excluindo..."
    },
    "drawer": {
      "subtitle": "Configure o campo personalizado",
      "nameLabel": "Nome do Campo",
      "namePlaceholder": "Ex: Prioridade",
      "uniqueKey": "Chave Única",
      "keyPlaceholder": "Ex: priority",
      "keyHintEdit": "A chave não pode ser alterada após a criação.",
      "keyHintNew": "Use apenas letras minúsculas, números e underscore. Gerada automaticamente a partir do nome.",
      "entityType": "Tipo de Entidade",
      "entityPlaceholder": "Selecione o tipo de entidade",
      "entityHintEdit": "O tipo de entidade não pode ser alterado após a criação.",
      "scopeLabel": "Escopo do Campo",
      "globalFieldPipelines": "Campo Global (aparece em todos os pipelines)",
      "selectPipelinesHint": "Selecione os pipelines onde este campo deve aparecer:",
      "loadingPipelines": "Carregando pipelines...",
      "noPipelines": "Nenhum pipeline disponível.",
      "globalFieldProducts": "Campo Global (aparece em todos os produtos)",
      "selectProductsHint": "Selecione os produtos onde este campo deve aparecer:",
      "loadingProducts": "Carregando produtos...",
      "noProducts": "Nenhum produto disponível.",
      "dataType": "Tipo de Dado",
      "selectDataType": "Selecione um tipo de dado",
      "dataTypeHintEdit": "O tipo de dado não pode ser alterado após a criação.",
      "options": "Opções",
      "optionsHint": "Adicione as opções disponíveis para seleção.",
      "optionPlaceholder": "Nome da opção",
      "removeOption": "Remover opção",
      "color": "Cor",
      "addOption": "Adicionar Opção",
      "decimalPlaces": "Casas Decimais",
      "decimalPlaceholder": "0 a 6 (deixe vazio para padrão)",
      "decimalHint": "Quantidade de casas decimais (0 a 6). Deixe vazio para usar o padrão do tipo.",
      "required": "Campo obrigatório",
      "filterable": "Permitir filtro por este campo",
      "cancel": "Cancelar",
      "saveChanges": "Salvar Alterações",
      "createField": "Criar Campo",
      "saving": "Salvando..."
    },
    "entities": {
      "Deal": "Negócio",
      "Organization": "Empresa",
      "Person": "Pessoa",
      "Product": "Produto"
    },
    "dataTypes": {
      "Text": "Texto",
      "ShortText": "Texto Curto",
      "LongText": "Texto Longo",
      "Number": "Número",
      "Integer": "Número Inteiro",
      "Decimal": "Número Decimal",
      "Currency": "Moeda",
      "Date": "Data",
      "DateTime": "Data + Hora",
      "Boolean": "Sim/Não",
      "SingleSelect": "Lista Suspensa",
      "MultiSelect": "Lista Múltipla",
      "Tags": "Etiquetas",
      "File": "Arquivo",
      "Url": "URL",
      "Phone": "Telefone",
      "Email": "E-mail"
    }
  },
  "brands": {
    "title": "Marcas",
    "subtitle": "Gerencie as marcas para organizar seus canais de comunicação",
    "newBrand": "Nova marca",
    "edit": "Editar",
    "active": "Ativa",
    "inactive": "Inativa",
    "channelCount": "{{count}} canal conectado",
    "channelsCount": "{{count}} canais conectados",
    "empty": "Nenhuma marca cadastrada. Clique em nova marca para criar.",
    "modalNew": {
      "title": "Criar marca",
      "subtitle": "Defina o nome e o logo usado no atendimento.",
      "name": "Nome",
      "namePlaceholder": "Ex.: Pipeup – Comercial",
      "nameHelper": "Esse nome aparece para o time no inbox.",
      "logo": "Logo",
      "logoLabel": "Logo",
      "logoUploadEmpty": "PNG/JPG até 2MB",
      "sendImage": "Enviar imagem",
      "dropHere": "Solte aqui para enviar",
      "logoUrlOptional": "URL do logo (opcional)",
      "logoPlaceholder": "https://.../logo.png",
      "logoRecommended": "Recomendado 512×512 (PNG com fundo transparente).",
      "logoUrlHint": "Cole a URL da sua logo ou selecione uma imagem",
      "select": "Selecionar",
      "changeLogo": "Alterar",
      "removeLogo": "Remover",
      "active": "Marca ativa",
      "activeDescription": "Disponível para uso no inbox.",
      "cancel": "Cancelar",
      "create": "Criar marca",
      "footerHint": "Dica: você pode alterar depois."
    },
    "modalEdit": {
      "title": "Editar marca",
      "name": "Nome",
      "namePlaceholder": "Ex: Premmio",
      "logo": "Logo (opcional)",
      "logoLabel": "Logo",
      "logoPlaceholder": "https://exemplo.com/logo.jpg",
      "logoUrlHint": "Cole a URL da sua logo ou selecione uma imagem",
      "select": "Selecionar",
      "changeLogo": "Alterar",
      "removeLogo": "Remover logo",
      "active": "Marca ativa",
      "deactivate": "Desativar marca",
      "cancel": "Cancelar",
      "save": "Salvar",
      "confirmDeactivate": "Tem certeza que deseja desativar a marca {{name}}? Ela não aparecerá no seletor de canais.",
      "no": "Não",
      "yesDeactivate": "Sim, desativar"
    }
  },
  "products": {
    "title": "Produtos",
    "subtitle": "Gerencie os produtos e serviços da sua empresa",
    "newProduct": "Novo Produto",
    "searchPlaceholder": "Buscar produtos...",
    "allCategories": "Todas as categorias",
    "all": "Todos",
    "active": "Ativo",
    "inactive": "Inativo",
    "search": "Buscar",
    "loading": "Carregando produtos...",
    "loadError": "Erro ao carregar produtos",
    "retry": "Tentar Novamente",
    "emptyTitle": "Nenhum produto encontrado",
    "emptyWithFilters": "Tente ajustar os filtros de busca",
    "emptyNoFilters": "Comece criando seu primeiro produto",
    "tableProduct": "Produto",
    "tableCategory": "Categoria",
    "tablePrice": "Preço",
    "tableCode": "Código",
    "tableActive": "Ativo",
    "tableActions": "Ações",
    "editProduct": "Editar produto",
    "deleteProduct": "Excluir produto",
    "paginatorReport": "Mostrando {first} a {last} de {totalRecords} produtos",
    "deleteModal": {
      "title": "Excluir Produto",
      "message": "Tem certeza que deseja excluir o produto",
      "warning": "A exclusão é permanente. O produto não aparecerá mais em novas propostas.",
      "cancel": "Cancelar",
      "delete": "Excluir",
      "deleting": "Excluindo..."
    },
    "drawer": {
      "titleNew": "Novo Produto",
      "titleEdit": "Editar Produto",
      "nameLabel": "Nome do Produto",
      "namePlaceholder": "Ex: Consultoria TI",
      "codeLabel": "Código",
      "codePlaceholder": "Ex: CTI-001",
      "codeHint": "Deve ser único dentro da empresa",
      "description": "Descrição",
      "descriptionPlaceholder": "Descrição do produto",
      "unitPrice": "Preço Unitário",
      "billingCycle": "Ciclo de Cobrança",
      "priceRules": "Regras de preço (opcional)",
      "enforcePriceRange": "Aplicar faixa de preço",
      "enforcePriceRangeHint": "Define limites para desconto e sobrepreço neste produto.",
      "maxDiscount": "Desconto máximo (%)",
      "maxDiscountHint": "Permite vender até X% abaixo do preço base.",
      "maxOverprice": "Sobrepreço máximo (%)",
      "maxOverpriceHint": "Permite vender até X% acima do preço base.",
      "requireReasonOutOfRange": "Exigir motivo fora da faixa",
      "category": "Categoria",
      "categoryPlaceholder": "Selecione uma categoria",
      "unit": "Unidade",
      "unitPlaceholder": "Selecione uma unidade",
      "unitWarning": "Sugestão: para cobrança recorrente, use unidade 'mês' ou 'ano'.",
      "active": "Ativo?",
      "cancel": "Cancelar",
      "saveChanges": "Salvar Alterações",
      "saveProduct": "Salvar Produto",
      "saving": "Salvando..."
    },
    "details": {
      "mainInfo": "Informações Principais",
      "name": "Nome",
      "category": "Categoria",
      "price": "Preço",
      "code": "Código",
      "unit": "Unidade",
      "billingCycle": "Ciclo de Cobrança",
      "active": "Ativo",
      "yes": "Sim",
      "no": "Não",
      "createdAt": "Criado em",
      "updatedAt": "Atualizado em",
      "description": "Descrição",
      "notes": "Observações",
      "activate": "Ativar",
      "edit": "Editar",
      "delete": "Excluir"
    },
    "billingCycles": { "Monthly": "Mensal", "Yearly": "Anual", "OneTime": "Único" },
    "categories": { "Service": "Serviço", "Software": "Software", "Training": "Treinamento", "Setup": "Configuração", "Consulting": "Consultoria", "Other": "Outro" },
    "units": { "Unit": "Unidade", "Hour": "Hora", "Day": "Dia", "Month": "Mês", "Year": "Ano", "Project": "Projeto" }
  },
  "proposalTemplates": {
    "title": "Modelos de Proposta",
    "subtitle": "Gerencie os modelos de proposta da sua empresa",
    "createTemplate": "Criar Modelo",
    "searchPlaceholder": "Buscar modelos...",
    "all": "Todos",
    "active": "Ativo",
    "inactive": "Inativo",
    "search": "Buscar",
    "loading": "Carregando modelos...",
    "loadError": "Erro ao carregar modelos",
    "retry": "Tentar Novamente",
    "emptyTitle": "Nenhum modelo encontrado",
    "emptyWithFilters": "Tente ajustar os filtros de busca",
    "emptyNoFilters": "Comece criando seu primeiro modelo",
    "tableModel": "Modelo",
    "tableType": "Tipo",
    "tableActive": "Ativo",
    "tableActions": "Ações",
    "deactivateTemplate": "Desativar modelo",
    "activateTemplate": "Ativar modelo",
    "editTemplate": "Editar modelo",
    "previewTemplate": "Visualizar preview",
    "duplicateTemplate": "Duplicar modelo",
    "deleteTemplate": "Excluir modelo",
    "paginatorReport": "Mostrando {first} a {last} de {totalRecords} modelos",
    "deleteModal": {
      "title": "Excluir Modelo",
      "message": "Tem certeza que deseja excluir o modelo",
      "warning": "Esta ação não pode ser desfeita.",
      "cancel": "Cancelar",
      "delete": "Excluir",
      "deleting": "Excluindo..."
    },
    "previewModal": {
      "title": "Preview do Modelo",
      "selectDeal": "Selecione um negócio para preview",
      "selectDealPlaceholder": "Selecione um negócio",
      "generating": "Gerando...",
      "generatePreview": "Gerar Preview",
      "generatingPreview": "Gerando preview...",
      "clickToGenerate": "Clique em \"Gerar Preview\" para visualizar o modelo renderizado.",
      "selectDealToPreview": "Selecione um negócio para visualizar o preview.",
      "tokenInfo": "Informações sobre Tokens",
      "tokensUsed": "Tokens utilizados:",
      "tokensUnresolved": "Tokens não resolvidos:",
      "close": "Fechar"
    },
    "drawer": {
      "titleNew": "Novo Modelo de Proposta",
      "titleEdit": "Editar Modelo:",
      "basicInfo": "Informações Básicas",
      "modelName": "Nome do Modelo",
      "modelNamePlaceholder": "Ex: Modelo Comercial, Proposta Técnica, etc.",
      "modelNameHint": "Este nome aparecerá no select ao criar uma nova proposta.",
      "typeNoneOptional": "Nenhum (opcional)",
      "modelType": "Tipo do Modelo",
      "modelTypeHint": "Selecione o tipo de modelo (opcional).",
      "active": "Ativo?",
      "documentStructure": "Estrutura do Documento",
      "header": "Cabeçalho",
      "documentTitle": "Título do documento",
      "documentTitlePlaceholder": "Ex: Proposta Comercial",
      "subtitle": "Subtítulo (opcional)",
      "subtitlePlaceholder": "Ex: Proposta personalizada para sua empresa",
      "body": "Corpo",
      "introduction": "Introdução",
      "introPlaceholder": "Texto introdutório da proposta...",
      "htmlCodePlaceholder": "Cole seu código HTML aqui...",
      "customSections": "Seções personalizadas",
      "addSection": "Adicionar Seção",
      "sectionTitlePlaceholder": "Título da seção",
      "sectionContentPlaceholder": "Conteúdo da seção...",
      "footer": "Rodapé",
      "finalNotes": "Observações finais",
      "finalNotesPlaceholder": "Observações finais...",
      "terms": "Termos e Condições",
      "termsPlaceholder": "Termos e condições...",
      "textMode": "Modo Texto",
      "htmlMode": "Modo HTML",
      "toggleHtmlModeTitle": "Alternar modo HTML",
      "variablesTitle": "Variáveis Disponíveis",
      "variablesHint": "(Clique em um campo e depois na variável)",
      "activeFieldNone": "Nenhum campo selecionado. Clique em um campo de texto para ativar.",
      "activeFieldLabel": "Campo ativo:",
      "preview": "Preview",
      "cancel": "Cancelar",
      "saveTemplate": "Salvar Modelo",
      "saving": "Salvando..."
    },
    "types": { "Commercial": "Comercial", "Technical": "Técnico", "Custom": "Personalizado" }
  },
  "contacts": {
    "title": "Contatos",
    "subtitle": "Gerencie seus contatos (Pessoas)",
    "newContact": "Novo Contato",
    "searchPlaceholder": "Buscar contatos...",
    "allCompanies": "Todas as empresas",
    "search": "Buscar",
    "loading": "Carregando contatos...",
    "emptyTitle": "Nenhum contato encontrado",
    "emptyWithFilters": "Tente ajustar os filtros de busca",
    "emptyNoFilters": "Comece criando seu primeiro contato",
    "tableContact": "Contato",
    "tableCompany": "Empresa",
    "tablePhoneEmail": "Telefone / Email",
    "tableSource": "Origem",
    "tableOwner": "Responsável",
    "tableCreatedAt": "Criado em",
    "tableActions": "Ações",
    "edit": "Editar",
    "associateToCompanyDeal": "Associar à empresa / negócio",
    "delete": "Excluir",
    "paginatorReport": "Mostrando {first} a {last} de {totalRecords} contatos",
    "deleteModal": {
      "title": "Excluir Contato",
      "message": "Tem certeza que deseja excluir o contato",
      "warning": "A exclusão é permanente. O contato não aparecerá mais na lista.",
      "cancel": "Cancelar",
      "delete": "Excluir",
      "deleting": "Excluindo..."
    },
    "associateModal": {
      "title": "Associar Contato",
      "message": "Associar",
      "messageTo": "a:",
      "company": "Empresa",
      "selectCompany": "Selecione uma empresa",
      "deal": "Negócio",
      "selectDeal": "Selecione um negócio",
      "cancel": "Cancelar",
      "associate": "Associar",
      "associating": "Associando..."
    },
    "drawer": {
      "editContact": "Editar Contato",
      "newContact": "Novo Contato",
      "subtitle": "Configure os dados do contato",
      "name": "Nome",
      "contactName": "Nome do Contato",
      "contactNameHint": "Nome da pessoa que responde pelo contato",
      "email": "Email",
      "emailOrPhoneOptional": "(opcional, mas Email ou Telefone obrigatório)",
      "phone": "Telefone",
      "whatsappOptIn": "Permitir contato via WhatsApp",
      "position": "Cargo",
      "positionPlaceholder": "Ex: Gerente de Vendas",
      "status": "Status",
      "statusPlaceholder": "Ex: Ativo, Inativo, Em análise",
      "source": "Origem",
      "responsible": "Responsável",
      "selectResponsible": "Selecione um responsável",
      "company": "Empresa",
      "selectCompany": "Selecione uma empresa",
      "description": "Descrição",
      "descriptionPlaceholder": "Observações sobre o contato",
      "cancel": "Cancelar",
      "save": "Salvar",
      "create": "Criar",
      "saving": "Salvando...",
      "namePlaceholder": "Ex: João Pereira",
      "contactNamePlaceholder": "Ex: João",
      "emailPlaceholder": "exemplo@email.com"
    },
    "errors": {
      "load": "Erro ao carregar contatos. Tente novamente.",
      "loadContact": "Erro ao carregar dados do contato.",
      "delete": "Erro ao excluir contato. Tente novamente.",
      "update": "Erro ao atualizar contato. Tente novamente.",
      "create": "Erro ao criar contato. Tente novamente.",
      "associate": "Erro ao associar contato. Tente novamente.",
      "associateNeedCompanyOrDeal": "É necessário informar pelo menos uma Empresa ou um Negócio para associar."
    },
    "toast": {
      "saved": "Contato criado com sucesso!",
      "updated": "Contato atualizado com sucesso!",
      "deleted": "Contato excluído com sucesso!",
      "deletedWithName": "Contato \"{{name}}\" excluído com sucesso!",
      "associated": "Contato associado com sucesso!"
    },
    "validation": {
      "nameRequired": "O nome é obrigatório.",
      "nameMax": "O nome deve ter no máximo 200 caracteres.",
      "contactNameRequired": "O nome do contato é obrigatório.",
      "contactNameMax": "O nome do contato deve ter no máximo 200 caracteres.",
      "emailInvalid": "O email deve ser válido.",
      "emailOrPhoneRequired": "É necessário informar pelo menos o Email ou o Telefone.",
      "phoneInvalid": "Formato inválido. Use: +55 (11) 98765-4321",
      "phoneE164": "O telefone deve estar no formato E.164 (ex: +5511987654321)."
    }
  },
  "companies": {
    "title": "Empresas",
    "subtitle": "Gerencie as empresas da sua base",
    "newCompany": "Nova Empresa",
    "searchPlaceholder": "Buscar empresas…",
    "industry": "Indústria",
    "owner": "Responsável",
    "date": "Data",
    "dateToday": "Hoje",
    "date7days": "Últimos 7 dias",
    "date30days": "Últimos 30 dias",
    "dateCustom": "Personalizado",
    "dateTo": "até",
    "search": "Buscar",
    "loading": "Carregando empresas...",
    "empty": "Nenhuma empresa encontrada.",
    "emptyWithFilters": "Tente ajustar os filtros de busca",
    "emptyNoFilters": "Comece criando sua primeira empresa",
    "tableCompany": "Empresa",
    "tableCnpj": "CNPJ",
    "tablePrimaryContact": "Contato Principal",
    "tablePhoneEmail": "Telefone / Email",
    "tableOwner": "Responsável",
    "tableCreatedAt": "Criado em",
    "tableActions": "Ações",
    "editCompany": "Editar empresa",
    "viewRelationships": "Ver relacionamentos",
    "deleteCompany": "Excluir empresa",
    "paginatorReport": "Mostrando {first} a {last} de {totalRecords} empresas",
    "deleteModal": {
      "title": "Excluir Empresa",
      "message": "Tem certeza que deseja excluir a empresa",
      "warning": "Esta ação não pode ser desfeita.",
      "cancel": "Cancelar",
      "delete": "Excluir",
      "deleting": "Excluindo..."
    },
    "drawer": {
      "editCompany": "Editar Empresa",
      "newCompany": "Nova Empresa",
      "basicInfo": "Informações Básicas",
      "companyName": "Nome da Empresa",
      "companyNamePlaceholder": "Ex: TechPro Ltda",
      "tradeName": "Nome Fantasia",
      "tradeNamePlaceholder": "Ex: TechPro",
      "cnpj": "CNPJ",
      "cnpjPlaceholder": "00.000.000/0000-00",
      "industry": "Indústria",
      "selectIndustry": "Selecione uma indústria",
      "size": "Tamanho",
      "selectSize": "Selecione o tamanho",
      "sizeSmall": "Pequena",
      "sizeMedium": "Média",
      "sizeLarge": "Grande",
      "contact": "Contato",
      "contactName": "Nome do Contato",
      "contactNamePlaceholder": "Ex: João Silva",
      "email": "Email",
      "emailPlaceholder": "contato@empresa.com.br",
      "phone": "Telefone (E.164)",
      "phoneFormat": "Formato: +5511999999999",
      "whatsappOptIn": "Permitir contato via WhatsApp",
      "website": "Website",
      "websitePlaceholder": "https://www.empresa.com",
      "address": "Endereço",
      "country": "País",
      "countryPlaceholder": "Brasil",
      "state": "Estado",
      "statePlaceholder": "SP",
      "city": "Cidade",
      "cityPlaceholder": "São Paulo",
      "addressLine1": "Endereço",
      "addressLine1Placeholder": "Rua Exemplo, 123",
      "complement": "Complemento",
      "complementPlaceholder": "Sala 45",
      "zipCode": "CEP",
      "zipCodePlaceholder": "01234-567",
      "additionalInfo": "Informações Adicionais",
      "status": "Status",
      "selectStatus": "Selecione o status",
      "statusActive": "Ativa",
      "statusLead": "Lead",
      "statusInactive": "Inativa",
      "source": "Origem",
      "selectSource": "Selecione a origem",
      "sourceWebForm": "Formulário Web",
      "sourceReferral": "Indicação",
      "sourceColdCall": "Ligação a Frio",
      "sourceEmail": "Email",
      "sourceEvent": "Evento",
      "sourceOther": "Outro",
      "description": "Descrição",
      "descriptionPlaceholder": "Descrição ou notas sobre a empresa...",
      "responsible": "Responsável",
      "selectResponsible": "Selecione um responsável",
      "cancel": "Cancelar",
      "saveCompany": "Salvar Empresa",
      "saving": "Salvando...",
      "loadFallbackWarning": "Alguns dados podem não estar completos. Verifique antes de salvar."
    },
    "details": {
      "tabDetails": "Detalhes",
      "tabContacts": "Contatos",
      "tabDeals": "Negócios",
      "tabActivities": "Atividades",
      "edit": "Editar",
      "cnpj": "CNPJ",
      "industry": "Indústria",
      "responsible": "Responsável",
      "contact": "Contato",
      "noContacts": "Nenhum contato associado",
      "noDeals": "Nenhum negócio associado",
      "probability": "Probabilidade",
      "noActivities": "Nenhuma atividade registrada",
      "name": "Nome",
      "position": "Cargo",
      "phone": "Telefone",
      "email": "Email",
      "contacts": "Contatos"
    },
    "errors": {
      "load": "Erro ao carregar empresas. Tente novamente.",
      "delete": "Erro ao excluir empresa. Tente novamente.",
      "update": "Erro ao atualizar empresa. Tente novamente.",
      "create": "Erro ao criar empresa. Tente novamente."
    },
    "validation": {
      "nameRequired": "Nome da empresa é obrigatório.",
      "emailRequired": "Email é obrigatório.",
      "emailInvalid": "Email inválido.",
      "phoneRequired": "Telefone é obrigatório.",
      "phoneE164": "Telefone deve estar no formato E.164 (ex: +5511999999999)."
    },
    "toast": {
      "saved": "Empresa criada com sucesso!",
      "updated": "Empresa atualizada com sucesso!",
      "deleted": "Empresa excluída com sucesso!",
      "deletedWithName": "Empresa \"{{name}}\" excluída com sucesso!"
    }
  },
  "reports": {
    "title": "Relatórios",
    "refresh": "Atualizar",
    "export": "Exportar",
    "saveView": "Salvar Visão",
    "tabs": {
      "overview": "Overview",
      "pipelines": "Pipelines",
      "deals": "Negócios",
      "proposals": "Propostas",
      "activities": "Atividades",
      "forecast": "Forecast"
    },
    "filters": {
      "period": "Período",
      "dateFrom": "De",
      "dateTo": "Até",
      "pipelines": "Pipelines",
      "owners": "Responsáveis",
      "status": "Status",
      "placeholderPipelines": "Selecione pipelines",
      "placeholderOwners": "Selecione responsáveis",
      "placeholderStatus": "Selecione status",
      "moreFilters": "Mais Filtros",
      "clear": "Limpar",
      "activeFilters": "Filtros ativos:",
      "minValue": "Valor Mínimo",
      "maxValue": "Valor Máximo",
      "onlyWithProposal": "Apenas com proposta",
      "onlyOverdue": "Apenas atrasadas",
      "periodToday": "Hoje",
      "periodLast7d": "Últimos 7 dias",
      "periodLast30d": "Últimos 30 dias",
      "periodThisMonth": "Este mês",
      "periodLast3m": "Últimos 3 meses",
      "periodThisYear": "Este ano",
      "periodCustom": "Personalizado",
      "dealStatusOpen": "Aberto",
      "dealStatusWon": "Ganho",
      "dealStatusLost": "Perdido",
      "pipelineId": "Pipeline {{id}}",
      "userId": "Usuário {{id}}"
    },
    "overview": {
      "kpiDealsCreated": "Negócios Criados",
      "kpiValueOpen": "Valor em Aberto",
      "kpiDealsWon": "Negócios Ganhos",
      "kpiConversionRate": "Taxa de Conversão",
      "kpiProposalsAccepted": "Propostas Aceitas",
      "chartFunnel": "Funil de Conversão",
      "chartTrend": "Tendência de Ganhos",
      "chartRanking": "Ranking de Responsáveis",
      "insightsTitle": "Destaques"
    },
    "pipelinesTab": {
      "chartConversionByStage": "Conversão por Estágio",
      "chartTimeInStage": "Tempo em Estágio (dias)",
      "chartValueByStage": "Valor por Estágio"
    },
    "dealsTab": {
      "chartCreatedVsWon": "Criados vs Ganhos",
      "chartWonByOwner": "Ganhos por Responsável",
      "chartWonByPipeline": "Ganhos por Pipeline",
      "loading": "Carregando negócios...",
      "empty": "Nenhum negócio encontrado",
      "headerDeal": "Negócio",
      "headerCompany": "Empresa",
      "headerValue": "Valor",
      "headerStage": "Etapa",
      "headerOwner": "Responsável",
      "headerStatus": "Status",
      "headerCreatedAt": "Criado em",
      "paginator": "Mostrando {first} a {last} de {totalRecords} negócios",
      "statusOpen": "Aberto",
      "statusWon": "Ganho",
      "statusLost": "Perdido"
    },
    "proposalsTab": {
      "kpiAcceptanceRate": "Taxa de Aceite",
      "kpiTotalProposals": "Total de Propostas",
      "kpiPending": "Propostas Pendentes",
      "chartAging": "Aging de Propostas",
      "chartByStatus": "Propostas por Status",
      "loading": "Carregando propostas...",
      "empty": "Nenhuma proposta encontrada",
      "headerNumber": "Número",
      "headerDeal": "Negócio",
      "headerCompany": "Empresa",
      "headerValue": "Valor",
      "headerStatus": "Status",
      "headerCreatedAt": "Criado em",
      "headerExpiry": "Vencimento",
      "paginator": "Mostrando {first} a {last} de {totalRecords} propostas",
      "noDate": "—"
    },
    "activitiesTab": {
      "kpiTotal": "Total de Atividades",
      "kpiCompleted": "Concluídas",
      "kpiOverdue": "Atrasadas",
      "chartCompletedByPeriod": "Concluídas por Período",
      "chartOverdueByOwner": "Atrasadas por Responsável",
      "chartByType": "Atividades por Tipo",
      "loading": "Carregando atividades...",
      "empty": "Nenhuma atividade encontrada",
      "headerTitle": "Título",
      "headerType": "Tipo",
      "headerRelatedTo": "Relacionado a",
      "headerOwner": "Responsável",
      "headerDueDate": "Prazo",
      "headerStatus": "Status",
      "headerCompletedAt": "Concluída em",
      "paginator": "Mostrando {first} a {last} de {totalRecords} atividades",
      "statusPending": "Pendente",
      "statusCompleted": "Concluída",
      "statusOverdue": "Atrasada",
      "noDate": "—"
    },
    "forecastTab": {
      "chartProjection": "Projeção",
      "chartByOwner": "Projeção por Responsável",
      "chartByPipeline": "Projeção por Pipeline",
      "topOpportunities": "Top Oportunidades",
      "loading": "Carregando oportunidades...",
      "empty": "Nenhuma oportunidade encontrada",
      "headerDeal": "Negócio",
      "headerValue": "Valor",
      "headerProbability": "Probabilidade",
      "headerExpectedValue": "Valor Esperado"
    },
    "toast": {
      "dataUpdated": "Dados atualizados",
      "exportTablesOnly": "Exportação disponível apenas para tabelas",
      "noDataForExport": "Dados não disponíveis para exportação",
      "noRowsForExport": "Nenhum dado disponível para exportação",
      "csvExported": "Arquivo CSV exportado com sucesso!",
      "exportError": "Erro ao exportar arquivo CSV",
      "viewSaved": "Visão salva com sucesso!"
    },
    "exportMenu": {
      "csvCurrentTable": "CSV (tabela atual)"
    },
    "csvHeaders": {
      "deal": "Negócio",
      "company": "Empresa",
      "value": "Valor",
      "stage": "Etapa",
      "owner": "Responsável",
      "status": "Status",
      "createdAt": "Criado em",
      "closedAt": "Fechado em",
      "number": "Número",
      "expiry": "Vencimento",
      "acceptedAt": "Aceito em",
      "title": "Título",
      "type": "Tipo",
      "relatedTo": "Relacionado a",
      "dueDate": "Prazo",
      "completedAt": "Concluída em",
      "probability": "Probabilidade"
    }
  },
  "preferences": {
    "pageTitle": "Configurações da Empresa",
    "pageSubtitle": "Personalize identidade, preferências do CRM e integrações.",
    "readOnlyBadge": "Somente leitura - Apenas administradores podem alterar",
    "unsavedChangesBadge": "Você tem alterações não salvas",
    "restoreDefaults": "Restaurar padrões",
    "saveChanges": "Salvar alterações",
    "tabIdentity": "Dados principais",
    "tabPreferences": "Preferências",
    "tabSecurity": "Usuários & Segurança",
    "tabCommunication": "Comunicação",
    "tabIntegrations": "Integrações",
    "loadErrorTitle": "Não foi possível carregar configurações.",
    "loadErrorHint": "Tente novamente mais tarde.",
    "reload": "Recarregar",
    "identity": {
      "companyDataTitle": "Dados da empresa",
      "companyDataDesc": "Informações usadas em propostas, comunicações e documentos.",
      "tradeName": "Nome fantasia",
      "legalName": "Razão social",
      "cnpj": "CNPJ",
      "phone": "Telefone",
      "email": "Email",
      "emailFinancialHint": "Email financeiro para receber cobranças e notas fiscais.",
      "timezone": "Timezone",
      "timezonePlaceholder": "Selecione um fuso horário",
      "timezoneHint": "Formato IANA (ex: America/Sao_Paulo, America/New_York)",
      "optionalUsedInProposals": "Opcional. Usado em propostas e rodapés, se informado.",
      "site": "Site",
      "logo": "Logotipo",
      "logoDesc": "Envie a marca para aplicar em propostas e documentos.",
      "logoLabel": "Logo",
      "changeLogo": "Alterar Logo",
      "select": "Selecionar",
      "logoUrlHint": "Cole a URL da sua logo ou selecione uma imagem",
      "removeLogo": "Remover logo",
      "logoPlaceholder": "https://exemplo.com/logo.jpg",
      "addressTitle": "Endereço",
      "addressDesc": "Informações de localização da empresa.",
      "countryCode": "Código do País",
      "state": "Estado",
      "city": "Cidade",
      "zipCode": "CEP",
      "addressLine1": "Logradouro",
      "addressNumber": "Número",
      "placeholders": {
        "tradeName": "Ex: Construtora Alfa",
        "legalName": "Ex: Construtora Alfa LTDA",
        "cnpj": "00.000.000/0000-00",
        "phone": "+55 11 98765-4321",
        "email": "contato@empresa.com.br",
        "city": "São Paulo",
        "zipCode": "01310-100",
        "addressLine1": "Rua ou Avenida",
        "addressNumber": "123",
        "countryCode": "BR",
        "state": "SP",
        "countryCodeHint": "Código ISO 3166-1 alpha-2 (ex: BR, US)",
        "stateHint": "Sigla do estado (ex: SP, RJ, MG)",
        "website": "https://..."
      }
    },
    "regional": {
      "title": "Regionalização",
      "desc": "Defina idioma e padrões de datas e moeda.",
      "language": "Idioma",
      "currency": "Moeda",
      "dateFormat": "Formato de data",
      "affectsLists": "Afeta visualização em listas e relatórios.",
      "currencyBRL": "Real (BRL)",
      "currencyUSD": "Dólar (USD)",
      "currencyEUR": "Euro (EUR)",
      "dateDDMM": "dd/MM/yyyy",
      "dateMMDD": "MM/dd/yyyy",
      "dateISO": "yyyy-MM-dd"
    },
    "notifications": {
      "title": "Notificações",
      "desc": "Som ao receber nova mensagem no Inbox (Instagram, WhatsApp, Webchat).",
      "soundNewMessage": "Som de nova mensagem",
      "volume": "Volume"
    },
    "accentPreview": "Preview",
    "buttonsPreview": "Botões",
    "appliedOnlyProposals": "Aplicado somente em propostas e documentos.",
    "numbering": {
      "title": "Numeração",
      "desc": "Padronize identificadores de proposta.",
      "prefix": "Prefix",
      "preview": "Preview",
      "sequenceAuto": "Sequência é gerada automaticamente."
    },
    "automation": {
      "title": "Automação leve",
      "desc": "Ative comportamentos simples para padronizar operação.",
      "countWeekends": "Contabilizar finais de semana em prazos",
      "countWeekendsHint": "Quando desativado, prazos ignoram sábado e domingo."
    },
    "security": {
      "allowedDomainsTitle": "Domínios permitidos",
      "allowedDomainsDesc": "Restringe cadastro/login a domínios específicos.",
      "add": "Adicionar",
      "domainHint": "Use apenas o domínio. O sistema normaliza automaticamente (aceita @, http://, www., etc.). Ex: empresa.com.br, @empresa.com.br, https://www.empresa.com.br",
      "domainPlaceholder": "empresa.com.br",
      "policiesTitle": "Políticas de acesso",
      "policiesDesc": "Defina regras simples para controle de usuários.",
      "requireCorporateDomain": "Exigir domínio corporativo",
      "requireCorporateDomainHint": "Quando ativo, apenas emails com domínios da lista acima podem ser cadastrados.",
      "addOneDomainWarning": "Adicione pelo menos 1 domínio antes de ativar esta opção.",
      "manualApproval": "Aprovação manual de novos usuários",
      "manualApprovalHint": "Quando ativo, novos usuários ficam pendentes até aprovação. Usuários já criados não são afetados."
    },
    "communication": {
      "deliverabilityTitle": "Entregabilidade",
      "deliverabilityDesc": "Regras para reduzir risco de spam.",
      "replyToDisclaimer": "Se o Reply-To do usuário tiver domínio diferente do FromAddress, alguns provedores podem reduzir entrega ou marcar como spam.",
      "replyToTitle": "Respostas de e-mail (Reply-To)",
      "replyToDesc": "Configure para onde as respostas aos e-mails enviados serão direcionadas.",
      "replyToUser": "Enviar respostas diretamente para o vendedor",
      "replyToUserHint": "Quando ativado, o campo Reply-To será o e-mail do vendedor responsável pelo envio.",
      "howItWorks": "Como funciona",
      "howItWorksBody": "O campo From continua sendo do sistema (ex: noreply@pipeup.com.br). Apenas o campo Reply-To muda para o e-mail do vendedor responsável pelo envio. Quando o destinatário responder ao e-mail, a resposta será direcionada para o vendedor, não para o sistema.",
      "deliverabilityWarningTitle": "Atenção: entregabilidade e rastreio",
      "deliverabilityWarning1": "As respostas irão direto para o e-mail do vendedor (fora do Pipeup).",
      "deliverabilityWarning2": "Em alguns cenários, pode haver impacto de entregabilidade dependendo do provedor e políticas de DMARC do destinatário.",
      "deliverabilityWarning3": "Recomendado apenas para comunicações 1:1 (vendas).",
      "emailSendingTitle": "Envio de e-mails",
      "emailSendingDesc": "Configure o remetente e o provedor de envio.",
      "sendingMode": "Modo de envio",
      "sendingModeDefault": "Padrão Pipeup",
      "sendingModeSmtp": "SMTP da empresa",
      "smtpTitle": "SMTP corporativo",
      "smtpDesc": "Envie e-mails usando seu domínio (recomendado para propostas).",
      "smtpHost": "SMTP Host",
      "smtpPort": "Porta",
      "smtpPortSSL": "SSL",
      "smtpPortTLS": "TLS",
      "smtpPortDefault": "Padrão",
      "smtpUser": "Usuário",
      "smtpPassword": "Senha",
      "smtpPasswordHint": "Preencha apenas para alterar.",
      "smtpEncryption": "Criptografia",
      "smtpPortHint": "Dica: 465 → SSL | 587 → TLS | 25 → Sem criptografia",
      "smtpRecommended": "Recomendado",
      "smtpPortWarning": "A porta {{port}} geralmente usa {{encryption}}",
      "fromAddress": "From Address",
      "fromNameTemplate": "From Name Template",
      "fromNameTemplateHint": "Tokens disponíveis: user.name, company.name",
      "testSmtp": "Testar SMTP",
      "whatsappLinkTitle": "WhatsApp (Link)",
      "whatsappLinkDesc": "Inicie conversas no WhatsApp com mensagens pré-preenchidas. Não requer conexão com API.",
      "enableWhatsApp": "Ativar WhatsApp",
      "enableWhatsAppHint": "OFF → botão WhatsApp não aparece no sistema | ON → botão aparece em Person / Deal / Organization",
      "requireConsent": "Exigir consentimento do contato",
      "requireConsentHint": "Somente permitir envio para contatos com consentimento ativo.",
      "templatesTitle": "Templates de WhatsApp",
      "templatesVariables": "Variáveis disponíveis: {{person.firstName}}, {{person.fullName}}, {{company.name}}, {{deal.title}}, {{deal.value}}, {{user.name}}",
      "templatesMax": "Máximo de {{max}} templates ({{current}}/{{max}})",
      "templateNamePlaceholder": "Nome do template",
      "templateContentPlaceholder": "Conteúdo da mensagem...",
      "default": "Padrão",
      "addTemplate": "Adicionar Template",
      "logActivity": "Registrar atividade automaticamente",
      "logActivityHint": "Registrar uma atividade sempre que o WhatsApp for iniciado."
    },
    "integrationsTab": {
      "webhooksTitle": "Webhooks",
      "webhooksDesc": "Receba eventos do Pipeup em seus sistemas.",
      "webhookUrl": "Webhook URL",
      "events": "Eventos",
      "active": "Ativo",
      "integrationsTitle": "Integrações",
      "integrationsDesc": "Conecte ferramentas usadas no seu fluxo.",
      "payin": "Payin",
      "currentPlan": "Plano atual",
      "status": "Status",
      "googleCalendar": "Google Calendar",
      "googleCalendarDesc": "Sincronize eventos e atividades",
      "nvoip": "Nvoip",
      "nvoipDesc": "WhatsApp Business API",
      "displayAfterConnection": "Será exibido automaticamente após conexão."
    },
    "testSmtpModal": {
      "title": "Testar SMTP",
      "passwordWarning": "Importante: Preencha a senha SMTP no formulário antes de testar. A senha não é salva permanentemente no navegador por segurança.",
      "sendTestTo": "Enviar teste para",
      "emailPlaceholder": "email@exemplo.com",
      "sending": "Enviando e-mail de teste...",
      "sendTest": "Enviar teste",
      "sendingBtn": "Enviando..."
    },
    "identityPreviewModal": {
      "title": "Preview de Identidade",
      "subtitle": "Visualização de como sua identidade será aplicada em propostas e documentos",
      "proposal": "Proposta",
      "validUntil": "Válida até",
      "client": "Cliente",
      "sampleCompany": "Empresa Exemplo Ltda.",
      "sampleCnpj": "CNPJ: 12.345.678/0001-90",
      "sampleEmail": "contato@exemplo.com.br",
      "itemsTitle": "Itens da Proposta",
      "item": "Item",
      "quantity": "Quantidade",
      "unitValue": "Valor Unitário",
      "total": "Total",
      "sampleProductA": "Produto Exemplo A",
      "sampleProductB": "Produto Exemplo B",
      "acceptProposal": "Aceitar Proposta",
      "companyNameFallback": "Nome da Empresa"
    }
  },
  "roles": {
    "title": "Perfis",
    "subtitle": "Controle os tipos de usuários e as permissões de acesso dentro do sistema.",
    "registerProfile": "Cadastrar Perfil",
    "searchPlaceholder": "Buscar perfis...",
    "status": "Status",
    "active": "Ativo",
    "inactive": "Inativo",
    "search": "Buscar",
    "loading": "Carregando perfis...",
    "emptyTitle": "Nenhum perfil encontrado",
    "emptyWithFilters": "Tente ajustar os filtros de busca",
    "emptyNoFilters": "Comece criando seu primeiro perfil",
    "tableName": "Nome",
    "tableCategory": "Categoria",
    "tableDescription": "Descrição",
    "tableUsers": "Usuários",
    "tableStatus": "Status",
    "tableActions": "Ações",
    "categorySystem": "Sistema",
    "categoryColaborador": "Colaborador",
    "userCountOne": "usuário",
    "userCountMany": "usuários",
    "zeroUsers": "0 usuários",
    "editProfile": "Editar perfil",
    "paginatorReport": "Mostrando {first} a {last} de {totalRecords} perfis",
    "drawer": {
      "titleNew": "Cadastrar Perfil",
      "titleEdit": "Editar Perfil",
      "titleEditName": "Editar Perfil: {{name}}",
      "systemProfileHint": "Perfil do sistema",
      "configurePermissionsHint": "Configure as permissões do perfil",
      "profileName": "Nome do Perfil",
      "namePlaceholder": "Ex.: SDR, Closer, Suporte, CS",
      "description": "Descrição",
      "descriptionPlaceholder": "Breve explicação do papel deste perfil",
      "category": "Categoria",
      "permissions": "Permissões",
      "canViewTeamDeals": "Pode ver negócios da equipe",
      "canEditTeamDeals": "Pode editar negócios da equipe",
      "canSendProposals": "Pode enviar propostas",
      "canEditTeamProposals": "Pode editar propostas da equipe",
      "canViewFinancialData": "Pode ver dados financeiros",
      "active": "Ativo",
      "usersLinkedInfo": "Usuários vinculados: Este perfil está sendo usado por {{count}} {{usersLabel}}.",
      "usersLinkedOne": "usuário",
      "usersLinkedMany": "usuários",
      "cancel": "Cancelar",
      "register": "Cadastrar Perfil",
      "saveProfile": "Salvar Perfil",
      "saving": "Salvando..."
    },
    "errors": {
      "load": "Erro ao carregar perfis. Tente novamente.",
      "companyRequired": "Não foi possível identificar a empresa. Faça login novamente.",
      "process": "Erro ao processar dados dos perfis. Tente novamente.",
      "update": "Erro ao atualizar perfil. Tente novamente.",
      "create": "Erro ao criar perfil. Tente novamente."
    },
    "toast": {
      "updated": "Perfil \"{{name}}\" atualizado com sucesso!",
      "created": "Perfil \"{{name}}\" criado com sucesso!"
    },
    "validation": {
      "nameRequired": "Nome do perfil é obrigatório."
    }
  },
  "users": {
    "title": "Usuários",
    "subtitle": "Gerencie os usuários e permissões de acesso da sua empresa.",
    "newUser": "Novo Usuário",
    "limitReached": "Limite atingido ({{used}}/{{limit}}). Faça upgrade ou adicione assentos em Assinatura.",
    "searchPlaceholder": "Buscar usuários...",
    "search": "Buscar",
    "loading": "Carregando usuários...",
    "emptyTitle": "Nenhum usuário encontrado",
    "emptyAdjustFilters": "Tente ajustar os filtros de busca",
    "emptyCreateFirst": "Comece criando seu primeiro usuário",
    "tableUser": "Usuário",
    "tableEmail": "Email",
    "tableContact": "Contato",
    "tableProfile": "Perfil",
    "tableStatus": "Status",
    "tableAccess": "Acesso",
    "tableActions": "Ações",
    "statusActive": "Ativo",
    "statusPending": "Pendente",
    "statusInactive": "Inativo",
    "actionApprove": "Aprovar usuário",
    "actionEdit": "Editar usuário",
    "actionDelete": "Excluir usuário",
    "paginatorReport": "Mostrando {first} a {last} de {totalRecords} usuários",
    "deleteModal": {
      "title": "Excluir Usuário",
      "confirmMessage": "Tem certeza que deseja excluir o usuário",
      "cannotUndo": "Esta ação não pode ser desfeita.",
      "cancel": "Cancelar",
      "deleting": "Excluindo...",
      "delete": "Excluir"
    },
    "approveModal": {
      "title": "Aprovar Usuário",
      "confirmMessage": "Tem certeza que deseja aprovar e ativar o usuário",
      "afterApprove": "O usuário poderá fazer login e acessar o sistema após a aprovação.",
      "cancel": "Cancelar",
      "approving": "Aprovando...",
      "approve": "Aprovar"
    },
    "limitModal": {
      "title": "Limite de usuários atingido",
      "message": "Sua empresa está usando todos os assentos disponíveis no plano ({{used}}/{{limit}} assentos).",
      "hint": "Para cadastrar novos usuários, faça upgrade do plano ou adicione assentos na tela de Assinatura. Lá você pode contratar assentos extras e pagar na hora (PIX ou cartão).",
      "close": "Fechar",
      "goToSubscription": "Ir para Assinatura"
    },
    "drawer": {
      "titleNew": "Novo Usuário",
      "titleEdit": "Editar Usuário",
      "subtitle": "Configure os dados do usuário",
      "name": "Nome",
      "email": "Email",
      "password": "Senha",
      "phone": "Telefone",
      "whatsapp": "WhatsApp",
      "type": "Tipo",
      "profile": "Perfil",
      "timezone": "Fuso Horário",
      "namePlaceholder": "Ex: João Silva",
      "emailPlaceholder": "Ex: joao@example.com",
      "phonePlaceholder": "(11) 91234-5678",
      "selectType": "Selecione o tipo do usuário",
      "typeAdministrator": "Administrador",
      "typeCollaborator": "Colaborador",
      "selectProfile": "Selecione um perfil",
      "selectTimezone": "Selecione um fuso horário",
      "sameNumberWhatsApp": "Mesmo número usado para WhatsApp",
      "cancel": "Cancelar",
      "saving": "Salvando...",
      "saveChanges": "Salvar Alterações",
      "saveUser": "Salvar Usuário",
      "allowedDomainsHint": "Domínios permitidos: {{domains}}",
      "validation": {
        "nameRequired": "Nome é obrigatório.",
        "emailRequired": "Email é obrigatório.",
        "emailInvalid": "Email inválido.",
        "domainNotInList": "O domínio \"{{domain}}\" não está na lista de domínios permitidos.",
        "phoneRequired": "Telefone é obrigatório.",
        "timezoneRequired": "Fuso horário é obrigatório.",
        "profileRequired": "Perfil é obrigatório para colaborador."
      }
    },
    "errors": {
      "load": "Erro ao carregar usuários. Tente novamente.",
      "companyNotFound": "Não foi possível identificar a empresa. Faça login novamente.",
      "loadUser": "Erro ao carregar dados do usuário. Tente novamente.",
      "delete": "Erro ao excluir usuário. Tente novamente.",
      "approve": "Erro ao aprovar usuário. Tente novamente.",
      "update": "Erro ao atualizar usuário. Tente novamente.",
      "create": "Erro ao criar usuário. Tente novamente.",
      "userIdNotFound": "ID do usuário não encontrado.",
      "domainNotAllowed": "O domínio do email não está na lista de domínios permitidos da empresa."
    },
    "toast": {
      "deleted": "Usuário \"{{name}}\" excluído com sucesso!",
      "updated": "Usuário \"{{name}}\" atualizado com sucesso!",
      "created": "Usuário \"{{name}}\" criado com sucesso!",
      "approved": "Usuário \"{{name}}\" aprovado e ativado com sucesso!",
      "activated": "Usuário \"{{name}}\" ativado com sucesso!",
      "blocked": "Usuário \"{{name}}\" bloqueado. O acesso ao sistema foi desativado.",
      "pending": "Usuário \"{{name}}\" permanecerá pendente até aprovação."
    }
  },
  "integrations": {
    "googleCalendarDescription": "Conecte sua agenda para criar e sincronizar reunioes do Pipeup",
    "title": "Apps & Integrações",
    "subtitle": "Conecte e gerencie integrações com sua agenda, WhatsApp e outras ferramentas",
    "comingSoon": "Em breve: novas integrações",
    "searchPlaceholder": "Buscar integrações…",
    "filterAll": "Todas",
    "filterEnabled": "Ativadas",
    "filterDisabled": "Desativadas",
    "search": "Buscar",
    "tableIntegration": "Integração",
    "tableType": "Tipo",
    "tableProvider": "Provedor",
    "tableStatus": "Status",
    "tableConnection": "Conexão",
    "tableActions": "Ações",
    "disable": "Desativar",
    "enable": "Ativar",
    "configure": "Configurar",
    "connect": "Conectar",
    "emptyTitle": "Nenhuma integração encontrada.",
    "emptyHint": "Tente ajustar os filtros de busca.",
    "paginatorReport": "Mostrando {first} a {last} de {totalRecords} integrações",
    "toggleModal": {
      "titleEnable": "Ativar Integração",
      "titleDisable": "Desativar Integração",
      "confirmEnable": "Tem certeza que deseja ativar a integração <strong>{{name}}</strong>?",
      "confirmDisable": "Tem certeza que deseja desativar a integração <strong>{{name}}</strong>?",
      "hintEnable": "Ao ativar, a integração começará a funcionar imediatamente.",
      "hintDisable": "Ao desativar, a integração será pausada e não processará eventos até ser reativada.",
      "cancel": "Cancelar",
      "disabling": "Desativando...",
      "enabling": "Ativando...",
      "disableBtn": "Desativar",
      "enableBtn": "Ativar"
    },
    "oauthPopup": {
      "success": "Integração efetuada com sucesso.",
      "successHint": "Você pode fechar esta janela e voltar à aplicação.",
      "error": "Erro ao conectar.",
      "closeWindow": "Fechar esta janela"
    },
    "types": { "calendar": "Agenda", "webhook": "Automação" },
    "connection": {
      "none": "Nenhuma configuração",
      "configured": "Configurado",
      "oneConnection": "1 conexão configurada",
      "connectionsCount": "{{count}} conexões configuradas",
      "errorTooltip": "Conexão com problema — reconecte"
    },
    "status": {
      "connected": "Conectado",
      "disconnected": "Desconectado",
      "error": "Erro",
      "enabled": "Ativada",
      "disabled": "Desativada",
      "paused": "Pausada",
      "notConfigured": "Não configurado"
    },
    "lastCall": "Última chamada: {{date}}",
    "toast": {
      "googleConnected": "Conta Google conectada com sucesso.",
      "googleUpdated": "Google Calendar atualizado com sucesso.",
      "integrationEnabled": "Integração \"{{name}}\" ativada com sucesso!",
      "integrationDisabled": "Integração \"{{name}}\" desativada com sucesso!",
      "connectError": "Erro ao conectar.",
      "sessionExpired": "Sessão expirada. Faça login novamente."
    },
    "googleCalendar": {
      "title": "Google Calendar",
      "subtitle": "Conecte uma conta Google para criar e sincronizar reuniões",
      "loading": "Carregando…",
      "statusSection": "Status da integração",
      "integrationActive": "Integração ativa",
      "connectionSection": "Conexão",
      "noAccount": "Nenhuma conta conectada",
      "connectGoogle": "Conectar conta Google",
      "connectHint": "Você poderá escolher qual calendário receberá os eventos.",
      "connectedAs": "Conectado como:",
      "swapAccount": "Trocar conta",
      "disconnect": "Desconectar",
      "disconnecting": "Desconectando…",
      "connectionError": "Conexão com problema: {{reason}}",
      "unknownError": "Erro desconhecido",
      "reconnect": "Reconectar",
      "defaultCalendar": "Calendário padrão",
      "selectCalendar": "Selecione um calendário…",
      "primary": "Principal",
      "eventsHint": "Eventos criados pelo Pipeup serão adicionados aqui.",
      "behavior": "Comportamento",
      "createOnSchedule": "Criar eventos automaticamente ao agendar uma reunião no Pipeup",
      "updateOnReschedule": "Atualizar evento ao reagendar no Pipeup",
      "cancelOnCancel": "Cancelar evento ao cancelar no Pipeup",
      "close": "Fechar",
      "testConnection": "Testar conexão",
      "testing": "Testando…",
      "save": "Salvar",
      "saving": "Salvando…",
      "selectCalendarRequired": "Selecione um calendário",
      "toast": {
        "sessionExpired": "Sessão expirada. Feche o modal e faça login novamente se necessário.",
        "loadError": "Erro ao carregar status do Google Calendar.",
        "disconnected": "Conta desconectada.",
        "disconnectError": "Erro ao desconectar.",
        "swapError": "Erro ao trocar conta.",
        "connectionOk": "Conexão OK.",
        "testError": "Erro ao testar conexão.",
        "connectUrlError": "Não foi possível obter o link de conexão.",
        "saveCalendarError": "Erro ao salvar calendário padrão.",
        "saveError": "Erro ao salvar."
      }
    },
    "webhook": {
      "title": "Webhooks",
      "subtitle": "Receba cadastros externos e crie leads automaticamente nos seus pipelines.",
      "enableWebhooks": "Ativar Webhooks",
      "back": "Voltar",
      "newWebhook": "Novo Webhook",
      "editWebhook": "Editar Webhook",
      "nameLabel": "Nome do webhook",
      "namePlaceholder": "Ex: Landing page vendas",
      "pipeline": "Pipeline",
      "selectPipeline": "Selecione um pipeline",
      "initialStage": "Etapa inicial",
      "selectStage": "Selecione a etapa inicial",
      "ownerOptional": "Responsável (opcional)",
      "noOwner": "Sem responsável",
      "endpointActive": "Endpoint ativo",
      "cancel": "Cancelar",
      "saveWebhook": "Salvar webhook",
      "save": "Salvar",
      "secretBannerTitle": "Secret gerado para: {{name}}",
      "secretBannerHint": "Copie e guarde este Secret. Por segurança, ele não será exibido novamente.",
      "copy": "Copiar",
      "dismissSecret": "Fechar",
      "yourWebhooks": "Seus Webhooks",
      "createWebhook": "Criar webhook",
      "emptyTitle": "Nenhum webhook criado",
      "emptyHint": "Crie um webhook para integrar seu site ou sistema ao Pipeup.",
      "tableName": "Nome",
      "tableDestino": "Destino",
      "tableStatus": "Status",
      "tableLastCall": "Última chamada",
      "tableActions": "Ações",
      "statusActive": "Ativo",
      "statusPaused": "Pausado",
      "copyUrl": "Copiar URL",
      "edit": "Editar",
      "moreActions": "Mais ações",
      "regenerateSecret": "Regenerar secret",
      "deleteWebhook": "Excluir webhook",
      "regenerateConfirmHint": "Isso vai invalidar o secret atual. Você precisará atualizar o integrador.",
      "regenerate": "Regenerar",
      "deleteModalTitle": "Excluir webhook \"{{name}}\"?",
      "deleteModalHint": "Este webhook deixará de aceitar requisições imediatamente. Essa ação não pode ser desfeita.",
      "deleteConfirmLabel": "Entendo que esta ação é irreversível",
      "payloadExample": "Exemplo de payload (POST)",
      "payloadHint": "Pipeline e etapa são definidos na configuração do webhook. O token deve ser enviado no header X-Pipeup-Webhook-Token.",
      "toast": {
        "webhooksEnabled": "Webhooks ativados.",
        "webhooksPaused": "Webhooks pausados.",
        "toggleError": "Erro ao alterar status.",
        "created": "Webhook criado com sucesso.",
        "updated": "Webhook atualizado.",
        "urlCopied": "URL copiada.",
        "secretRegenerated": "Secret regenerado. Atualize seu integrador.",
        "secretCopied": "Secret copiado.",
        "exampleCopied": "Exemplo copiado.",
        "deleteSuccess": "Webhook excluído com sucesso.",
        "deleteError": "Erro ao excluir webhook.",
        "regenerateError": "Erro ao regenerar secret.",
        "saveError": "Erro ao salvar."
      },
      "validation": {
        "nameRequired": "Informe o nome do webhook",
        "pipelineRequired": "Selecione um pipeline",
        "stageRequired": "Selecione a etapa inicial"
      }
    },
    "catalog": {
      "title": "Adicionar integração",
      "googleCalendarTitle": "Google Calendar",
      "googleCalendarDesc": "Conecte sua agenda para criar e sincronizar reuniões do Pipeup.",
      "add": "Adicionar"
    },
    "drawer": {
      "title": "Integrações",
      "description": "Configure as integrações disponíveis para conectar o Pipeup com outras ferramentas.",
      "emailTitle": "Integração de Email",
      "emailDesc": "Conecte sua conta de email",
      "provider": "Provedor",
      "whatsappTitle": "WhatsApp API (Nvoip)",
      "whatsappDesc": "Conecte com Nvoip para envio de mensagens",
      "whatsappHint": "Configure as credenciais da API Nvoip nas configurações avançadas.",
      "googleCalendarTitle": "Google Calendar",
      "googleCalendarDesc": "Sincronize eventos e atividades",
      "googleCalendarHint": "Faça login com sua conta Google para sincronizar eventos.",
      "googleDriveTitle": "Google Drive",
      "googleDriveDesc": "Acesse e armazene arquivos",
      "googleDriveHint": "Conecte sua conta Google Drive para acessar arquivos.",
      "webhooksTitle": "Webhooks Básicos",
      "webhooksDesc": "Configure webhooks para integrações customizadas",
      "webhooksHint": "Configure URLs de webhook nas configurações avançadas.",
      "cancel": "Cancelar",
      "save": "Salvar Integrações",
      "saving": "Salvando..."
    }
  },
  "channels": {
    "title": "Canais",
    "subtitle": "Gerencie os canais de comunicação por marca",
    "brand": "Marca",
    "comingSoon": "Em breve",
    "badgeComingSoon": "Em breve",
    "recommended": "Recomendado",
    "emptySelectBrand": "Selecione uma marca para configurar os canais.",
    "ariaConnectInstagram": "Conectar Instagram",
    "connect": "Conectar",
    "configure": "Configurar",
    "manage": "Gerenciar",
    "statusConnected": "Conectado",
    "statusNotConnected": "Não conectado",
    "descriptions": {
      "whatsapp": "Canal oficial da Meta via API",
      "instagram": "Mensagens Direct na Inbox",
      "messenger": "Conversas do Facebook Messenger",
      "telegram": "Bot Telegram integrado",
      "webchat": "Chat no seu site"
    },
    "webchat": {
      "modalTitle": "Webchat",
      "modalSubtitle": "Marca: {{brand}}",
      "loading": "Carregando configurações...",
      "stepAppearance": "Aparência",
      "stepInstall": "Instalação",
      "stepRouting": "Roteamento",
      "stepSecurity": "Segurança",
      "isEnabled": "Ativar Webchat nesta marca",
      "isEnabledHelper": "Ao ativar, o widget poderá ser usado no site após instalar o script.",
      "savedAsDraft": "Salvo como rascunho",
      "sectionIdentity": "Identidade",
      "sectionMessages": "Mensagens",
      "sectionTheme": "Tema",
      "displayName": "Nome exibido",
      "displayNamePlaceholder": "Atendimento {{brand}}",
      "displayNameHelper": "Aparece no topo do chat.",
      "displayNameWarning": "Obrigatório para ativar",
      "welcomeMessage": "Mensagem de boas-vindas",
      "welcomeMessageHelper": "Mensagem enviada automaticamente ao abrir o chat.",
      "requireNameBeforeChat": "Solicitar nome antes da primeira mensagem",
      "requireNameHelper": "Ajuda a qualificar leads, mas pode reduzir conversão.",
      "logoOptional": "Logo (opcional)",
      "logoHintRecommended": "Recomendado: PNG/SVG até 1MB",
      "logoHintOptional": "Opcional. Se não enviar, usaremos as iniciais.",
      "upload": "Upload",
      "useUrl": "Usar URL",
      "changeLogo": "Trocar",
      "removeLogo": "Remover",
      "logoUploading": "Enviando…",
      "logoUrlLabel": "Cole a URL",
      "logoUrlApply": "Aplicar",
      "logoUrlCancel": "Cancelar",
      "logoUrlPlaceholder": "https://exemplo.com/logo.png",
      "logoFileTypeError": "Formato inválido. Use PNG/SVG.",
      "logoFileSizeError": "Arquivo deve ter no máximo 1MB.",
      "logoUrlInvalid": "URL deve começar com https://",
      "primaryColor": "Cor primária",
      "primaryColorInvalid": "Cor inválida",
      "theme": "Tema",
      "themeLight": "Claro",
      "themeDark": "Escuro",
      "themeAuto": "Automático",
      "position": "Posição do widget",
      "positionBottomRight": "Inferior direita",
      "positionBottomLeft": "Inferior esquerda",
      "preview": "Pré-visualização",
      "allowedOriginsWarning": "Você vai configurar no passo Segurança.",
      "publicKey": "Chave do Widget (Public Key)",
      "publicKeyPlaceholder": "Será gerada ao salvar",
      "publicKeyEmptyHint": "Não foi possível carregar a chave. Reabra o modal.",
      "copy": "Copiar",
      "copied": "Copiado!",
      "copySnippet": "Copiar snippet",
      "rotateKey": "Gerar nova chave",
      "rotateKeySuccess": "Nova chave gerada. Atualize o snippet no seu site.",
      "rotateKeyError": "Não foi possível gerar nova chave. Tente novamente.",
      "disableWebchat": "Desativar Webchat",
      "enableWebchat": "Ativar Webchat",
      "saved": "Configurações salvas",
      "installScript": "Script de instalação",
      "installHint": "Cole antes do </body>.",
      "allowedOriginsHint": "Funciona apenas nos domínios permitidos (Segurança).",
      "installHowToTitle": "Como instalar no seu site",
      "installStep1": "Copie o código acima.",
      "installStep2": "Cole antes da tag </body> no HTML do seu site.",
      "installStep3": "Publique as alterações.",
      "installDomainsNote": "O widget só funcionará nos domínios permitidos configurados na etapa Segurança.",
      "installShowExample": "Ver exemplo",
      "installExampleComment": "Seu conteúdo",
      "createLeadAutomatically": "Criar Lead automaticamente",
      "defaultTeam": "Time/Fila padrão",
      "noTeam": "Nenhum",
      "noTeamsHint": "Sem times cadastrados. Crie um time nas configurações.",
      "businessHoursEnabled": "Respeitar horário de atendimento",
      "businessHoursStart": "Início",
      "businessHoursEnd": "Fim",
      "offlineMessage": "Mensagem offline",
      "allowedOrigins": "Domínios permitidos (Allowed Origins)",
      "originPlaceholder": "https://www.seudominio.com",
      "originFormatHint": "Use scheme + host, sem path (ex.: https://www.exemplo.com).",
      "testDomain": "Testar domínio",
      "testDomainBtn": "Testar",
      "testDomainOk": "OK — Domínio permitido.",
      "testDomainBlocked": "Bloqueado — Adicione este domínio na lista acima e salve.",
      "originMustBeHttps": "O domínio deve começar com https://",
      "originInvalid": "URL do domínio inválida.",
      "add": "Adicionar",
      "securityNote": "O widget só funciona nos domínios permitidos. Se adicionar domínio errado, o Webchat não aparece.",
      "cancel": "Cancelar",
      "back": "Voltar",
      "next": "Próximo",
      "save": "Salvar",
      "saveAndActivate": "Salvar e ativar",
      "saveDraft": "Salvar rascunho",
      "saveAndPublish": "Salvar e publicar",
      "toastConfigSaved": "Configurações salvas",
      "statusNotConfigured": "Não configurado",
      "statusActive": "Ativo",
      "statusInactive": "Desativado",
      "badgeNotConfigured": "Não configurado",
      "badgeActive": "Ativo",
      "badgeDisabled": "Desativado",
      "badgeIncomplete": "Configuração incompleta",
      "errorAllowedOriginsRequired": "Adicione pelo menos um domínio permitido para ativar o Webchat.",
      "errorDisplayNameRequired": "Informe o nome exibido.",
      "errorDefaultTeamRequired": "Com \"Criar Lead automaticamente\" ativo e times cadastrados, selecione um time/fila padrão.",
      "errorInvalidColor": "Cor primária inválida (use #RRGGBB).",
      "errorOfflineMessageRequired": "Informe a mensagem offline.",
      "errorBusinessHours": "Horário de início deve ser anterior ao fim.",
      "errorSave": "Não foi possível salvar as configurações. Tente novamente.",
      "errorLogoUpload": "Não foi possível enviar o logo. Verifique o formato (PNG/SVG, máx. 1MB) ou tente novamente."
    },
    "statusLimited": "Limitado",
    "statusConfigPending": "Configuração pendente",
    "statusError": "Erro",
    "statusAttention": "Atenção",
    "retry": "Tentar novamente",
    "loading": "Carregando...",
    "emptyCreateBrand": "Crie sua primeira marca para gerenciar os canais.",
    "createBrand": "Criar marca",
    "instagram": {
      "subtitle": "Mensagens Direct na Inbox",
      "attentionTooltip": "Reconectar para voltar a receber e enviar mensagens",
      "brandInactive": "Marca inativa",
      "settingsTitle": "Configurações do Instagram",
      "wizardTitle": "Conectar Instagram",
      "wizardSubtitle": "Conecte sua conta profissional do Instagram para receber mensagens direto na Inbox do Pipeup.",
      "stepProgress": "Passo",
      "step1BeforeContinue": "Antes de continuar, verifique:",
      "step1Check1": "Sua conta do Instagram é Profissional (Business ou Creator)",
      "step1Check2": "Está vinculada a uma Página do Facebook",
      "step1Check3": "Você é Administrador da Página",
      "step1AfterConnect": "Após conectar:",
      "step1After1": "As mensagens do Instagram Direct aparecerão na sua Inbox",
      "step1After2": "Você poderá responder pelo Pipeup",
      "step1After3": "A conversa ficará associada à sua empresa",
      "step1CommonIssues": "Caso algo não funcione",
      "step1CommonIssuesDetail": "Geralmente está relacionado às permissões da Página ou ao tipo da conta do Instagram.",
      "step1CommonIssue1": "Instagram pessoal não funciona",
      "step1CommonIssue2": "Página sem permissão de administrador",
      "step1CommonIssue3": "Conta não vinculada corretamente à Página",
      "step1HowToVerify": "Como verificar se minha conta está correta?",
      "step1HowToVerifyDetail": "Instagram → Configurações → Conta → Tipo de conta. Facebook → Configurações da Página → Funções da Página.",
      "step1Cta": "Conectar Instagram",
      "step1Intro": "Para conectar o Instagram ao Pipeup:",
      "step1Requirement": "É necessário ter um perfil profissional vinculado a uma Página do Facebook.",
      "step1WhatHappens": "As mensagens do Instagram Direct passarão a aparecer na Inbox do Pipeup.",
      "step2Intro": "Faça login na sua conta do Facebook para autorizar o acesso às páginas e contas do Instagram.",
      "step2Cta": "Clique no botão abaixo para abrir o login do Facebook em uma nova janela.",
      "step2LoginFacebook": "Entrar com Facebook",
      "step2ContinueHint": "Conclua o login com Facebook acima para continuar.",
      "step2WaitingAuth": "Aguardando autenticação…",
      "step2HelpPopup": "Finalize o login no popup para continuar.",
      "step2Success": "Conectado ao Meta com sucesso.",
      "step2ErrorPopupBlocked": "Permita popups para continuar.",
      "step2ErrorPopupClosed": "Janela de login fechada antes de concluir.",
      "step2ErrorMetaConnect": "Falha ao conectar Meta.",
      "errorCode": "Código do erro",
      "step3Page": "Página do Facebook",
      "step3SelectPage": "Selecione uma página",
      "step3LoadingPages": "Carregando páginas…",
      "step3LoadingPagesAux": "Buscando páginas vinculadas à sua conta…",
      "step3NoPagesPlaceholder": "Nenhuma página encontrada",
      "step3NoPagesEmpty": "Não encontramos páginas com Instagram vinculado…",
      "step3NoPagesFound": "Nenhuma página do Facebook foi encontrada. Verifique se você é administrador da página e tente novamente.",
      "step3NoPagesHint": "É necessário ser administrador de uma Página do Facebook com conta Instagram vinculada.",
      "step3TryAgain": "Tentar novamente",
      "step3ViewRequirements": "Ver requisitos",
      "step3DebugTitle": "Debug (suporte)",
      "step3DebugBrandFlow": "Marca do fluxo",
      "step3DebugRequestId": "ID da solicitação",
      "step3DebugReason": "Motivo",
      "step3DebugScopesMissing": "scopes.missing",
      "step3DebugGraphCalls": "graph.calls",
      "step3PagesError": "Não foi possível carregar as páginas do Facebook.",
      "step3IgAccount": "Conta do Instagram",
      "step3SelectIg": "Selecione a conta",
      "step3NoIgLinked": "Como conectar o Instagram a uma Página.",
      "step4NoInbox": "Nenhuma Inbox cadastrada. Crie uma Inbox primeiro.",
      "step4LoadingInboxes": "Carregando inboxes…",
      "step4NoInboxTitle": "Nenhuma Inbox encontrada",
      "step4NoInboxHint": "Sem problema — ao finalizar, criaremos automaticamente a Inbox Principal.",
      "step4ManageInboxes": "Gerenciar inboxes",
      "step4InboxCreatedNow": "Inbox Principal criada automaticamente.",
      "step4InvalidInboxId": "A Inbox selecionada não é válida. Selecione outra.",
      "step4InstagramFound": "Instagram encontrado e vinculado.",
      "step4LinkInstagramInstruction": "Vincule um Instagram profissional a esta Página no Meta Business Suite.",
      "step4LinkInstagramFirst": "É necessário vincular um perfil Instagram à página para continuar.",
      "step4Title": "Confirmar conexão",
      "step4PageSelected": "Página selecionada",
      "step4IgLinked": "Instagram vinculado",
      "step4ActivateHint": "Ao ativar, suas mensagens do Instagram Direct começarão a aparecer na Inbox do Pipeup.",
      "step4CtaActivate": "Ativar canal",
      "step4CtaBack": "Voltar",
      "step4Activating": "Ativando…",
      "step4ToastSuccess": "Instagram conectado com sucesso.",
      "step4ErrorToken": "Não conseguimos concluir a autenticação. Tente novamente.",
      "step4ErrorPages": "Não encontramos páginas acessíveis. Verifique se você é admin da Página.",
      "step4ErrorIgLinked": "Essa Página não possui um Instagram profissional vinculado. Vincule no Meta Business Suite e tente novamente.",
      "step4ErrorWebhook": "Canal conectado, mas recebimento de mensagens ainda não está ativo. Contate o suporte.",
      "step4ErrorActivationCode": "Código de ativação inválido ou expirado. Refaça a conexão com o Instagram.",
      "step5Done": "Instagram conectado e ativo.",
      "cancel": "Cancelar",
      "continue": "Continuar",
      "back": "Voltar",
      "activateChannel": "Ativar canal",
      "goToInbox": "Ir para Inbox",
      "close": "Fechar",
      "connectedAccount": "Conta conectada",
      "inboxBinding": "Vinculação na Inbox",
      "attentionBanner": "A conexão precisa ser revalidada.",
      "reconnect": "Reconectar",
      "disconnectConfirmTitle": "Desconectar Instagram?",
      "disconnectConfirmMessage": "Ao desconectar, você para de receber e enviar mensagens por aqui."
    },
    "connectLinkedin": {
      "title": "Conectar LinkedIn",
      "body": "Autorize o Pipeup a acessar suas mensagens do LinkedIn.",
      "cancel": "Cancelar",
      "connectWithLinkedin": "Conectar com LinkedIn"
    },
    "manageLinkedin": {
      "backChannels": "Canais",
      "backToChannels": "Voltar aos canais",
      "disconnect": "Desconectar",
      "tabGeneral": "Geral",
      "tabInbox": "Inbox",
      "tabTechnical": "Técnico",
      "hybridAlert": "Modo híbrido: as mensagens do LinkedIn ainda não são sincronizadas. Esta conexão é usada para roteamento e configuração.",
      "status": "Status",
      "mode": "Modo",
      "displayName": "Nome exibido",
      "profileUrl": "URL do perfil",
      "type": "Tipo",
      "lastSync": "Última sincronização",
      "notSyncedYet": "Ainda não sincronizado",
      "linkedInbox": "Inbox vinculada",
      "defaultResponsible": "Responsável padrão",
      "autoTags": "Tags automáticas",
      "saveChanges": "Salvar alterações",
      "selectInbox": "Selecione a inbox",
      "noInboxes": "Nenhuma inbox disponível. Crie uma nas configurações.",
      "newTag": "Nova tag",
      "addTag": "Adicionar tag",
      "webhookUrl": "URL do webhook",
      "copy": "Copiar",
      "copied": "Copiado",
      "enabledEvents": "Eventos habilitados",
      "recentLogs": "Logs recentes",
      "noRecentLogs": "Nenhum log recente",
      "dateTime": "Data / Hora",
      "event": "Evento",
      "technicalNotAvailable": "Dados técnicos não disponíveis.",
      "none": "Nenhum",
      "brandFallback": "Marca",
      "connectedAccount": "Conta conectada",
      "disconnectConfirmTitle": "Desconectar LinkedIn?",
      "disconnectConfirmMessage": "Isso desativará o canal para esta marca.",
      "disconnectConfirmCancel": "Cancelar",
      "disconnectConfirmConfirm": "Desconectar",
      "finishConfigCallout": "Finalize a configuração para ativar o canal.",
      "saveAndActivate": "Salvar e ativar",
      "cancel": "Cancelar",
      "configSaved": "Configuração salva",
      "inboxRequired": "Selecione uma inbox."
    },
    "config": {
      "channelSetup": "Configuração do canal",
      "reconnect": "Reconectar",
      "disconnect": "Desconectar",
      "deactivate": "Desativar",
      "viewSnippet": "Ver snippet",
      "tabGeneral": "Geral",
      "tabAttendees": "Atendentes",
      "tabReplies": "Respostas automáticas",
      "tabInbox": "Inbox",
      "tabTemplates": "Templates",
      "tabTechnical": "Técnico",
      "tabInstallation": "Instalação",
      "tabAppearance": "Aparência",
      "connectedNumber": "Número conectado",
      "numberMasked": "Número mascarado por segurança.",
      "connectionStatus": "Status da conexão",
      "lastSync": "Última sincronização",
      "inboxIntro": "Todas as mensagens deste canal caem na Inbox. Lead/Deal são criados manualmente no chat.",
      "linkedBox": "Caixa vinculada",
      "defaultResponsible": "Responsável padrão (opcional)",
      "linkedBoxPlaceholder": "Ex: Inbox principal",
      "responsiblePlaceholder": "Para atribuição na Inbox",
      "autoTags": "Tags automáticas (opcional)",
      "autoTagsInboxHint": "Para organização e filtro na Inbox.",
      "messageTemplates": "Templates de mensagem",
      "syncTemplates": "Sincronizar templates",
      "templateName": "Nome",
      "templateStatus": "Status",
      "templateLanguage": "Idioma",
      "webhookUrl": "Webhook URL",
      "webhookReadOnly": "Somente leitura. Configure esta URL no Meta for Developers.",
      "events": "Eventos",
      "recentLogs": "Logs recentes",
      "logTime": "Hora",
      "logEvent": "Evento",
      "logDetail": "Detalhe",
      "linkedinAccount": "Conta conectada",
      "linkedinProfileName": "Nome do perfil",
      "linkedinUrl": "URL",
      "linkedinType": "Tipo",
      "linkedinLastSync": "Última sincronização",
      "linkedinWebhook": "Webhook",
      "linkedinWebhookUrl": "Webhook URL",
      "linkedinEventsEnabled": "Eventos habilitados",
      "linkedinLogs": "Logs recentes",
      "logDateTime": "Data/Hora",
      "logStatus": "Status",
      "channelStatus": "Status do canal",
      "channelStatusActive": "Conectado e ativo. Última sincronização: há alguns minutos.",
      "displayName": "Nome exibido (opcional)",
      "businessHours": "Horário de atendimento",
      "businessHoursPlaceholder": "Em produção, aqui seriam configurados horários e mensagem fora do expediente.",
      "whoAttends": "Quem atende este canal",
      "whoAttendsIntro": "Atribua membros da equipe para receber conversas do {{channelName}}.",
      "allInboxUsers": "Todos os usuários com acesso ao Inbox",
      "default": "Padrão",
      "attendeesPlaceholder": "Em produção: lista de usuários com toggle por pessoa.",
      "welcomeMessage": "Mensagem de boas-vindas",
      "welcomeMessageIntro": "Enviada automaticamente quando uma nova conversa é iniciada.",
      "messagePlaceholder": "Digite a mensagem...",
      "quickReplies": "Respostas rápidas",
      "quickRepliesPlaceholder": "Em produção: atalhos de texto e respostas pré-definidas.",
      "identification": "Identificação",
      "attendantDisplayName": "Nome exibido do atendente",
      "attendantPlaceholder": "Ex: Equipe Comercial",
      "avatar": "Avatar",
      "avatarPlaceholder": "URL da imagem",
      "language": "Idioma",
      "allowedDomains": "Domínios permitidos",
      "addDomain": "adicionar domínio",
      "status": "Status",
      "webchatActive": "Webchat ativo",
      "webchatInactiveHint": "Quando inativo, o widget não será exibido nos sites configurados.",
      "snippet": "Snippet",
      "copy": "Copiar",
      "snippetHint": "Cole antes do </body> nas páginas onde o webchat deve aparecer.",
      "authorizedDomains": "Domínios autorizados",
      "test": "Teste",
      "openTestPage": "Abrir página de teste",
      "testPageHint": "Envie uma mensagem para ver na Inbox.",
      "button": "Botão",
      "primaryColor": "Cor primária",
      "position": "Posição",
      "positionRight": "Direita",
      "positionLeft": "Esquerda",
      "buttonText": "Texto do botão (opcional)",
      "buttonTextPlaceholder": "Ex: Fale conosco",
      "initialMessage": "Mensagem inicial",
      "quickButtons": "Botões rápidos (máx. 4)",
      "quickButtonN": "Botão {{n}}",
      "remove": "Remover",
      "label": "Label",
      "buttonLabelPlaceholder": "Label do botão",
      "appliedTag": "Tag aplicada",
      "tagPlaceholder": "Tag (para organização e filtro na Inbox)",
      "add": "adicionar",
      "newTag": "Nova tag",
      "addTag": "Adicionar",
      "profileTypeProfile": "Perfil",
      "profileTypePage": "Página"
    },
    "conectarCanal": {
      "stepOf": "Passo {{step}} de {{maxStep}}",
      "linkedinAuthorize": "Autorize o Pipeup a acessar suas mensagens do LinkedIn.",
      "tokenPlaceholder": "Cole o token ou a URL de configuração fornecida pelo {{channelName}}.",
      "tokenLabel": "Token ou URL",
      "tokenInputPlaceholder": "Cole aqui...",
      "reviewPermissions": "Revise as permissões e clique em Conectar para ativar o canal.",
      "channelPermissions": "Canal: {{channelName}}. Em produção, aqui apareceriam as permissões solicitadas.",
      "channelConnected": "{{channelName}} conectado",
      "channelReadyInbox": "O canal já pode receber conversas no Inbox.",
      "cancel": "Cancelar",
      "connectLinkedIn": "Conectar com LinkedIn",
      "continue": "Continuar",
      "connect": "Conectar",
      "close": "Fechar",
      "connectTitle": "Conectar {{channelName}}",
      "almostThere": "Quase lá"
    },
    "conectarWhatsApp": {
      "wizardTitle": "Conectar WhatsApp",
      "subtitle": "Conecte seu número WhatsApp Cloud API para receber e enviar mensagens na Inbox.",
      "title": "Dados do número",
      "credentials": "Token de acesso",
      "confirm": "Confirmação",
      "concluded": "Concluído",
      "connected": "Conectado",
      "stepOf": "Passo {{step}} de {{maxStep}}",
      "stepProgress": "Passo — {{step}}/{{maxStep}}",
      "wabaId": "WABA ID",
      "wabaIdPlaceholder": "ID da conta Business WhatsApp",
      "phoneNumberId": "Phone Number ID",
      "phoneNumberIdPlaceholder": "Ex.: 123456789012345",
      "displayPhone": "Número de exibição",
      "displayPhonePlaceholder": "Opcional",
      "verifiedName": "Nome verificado",
      "verifiedNamePlaceholder": "Opcional",
      "accessToken": "Access Token",
      "accessTokenPlaceholder": "Token do System User (Meta)",
      "tokenHelptext": "Token do System User do cliente com permissão para WhatsApp Cloud API. Usado apenas para operar este número; armazenado com segurança.",
      "validateConnection": "Validar conexão",
      "connectAndValidate": "Conectar e Validar",
      "confirmWindowRule": "Entendo que mensagens fora da janela de 24h exigem template (Utility/Auth).",
      "chooseMethod": "Escolha como deseja conectar o WhatsApp.",
      "methodCloud": "WhatsApp Cloud API",
      "methodOther": "Outro provedor",
      "comingSoon": "(em breve)",
      "enterCredentials": "Informe as credenciais do seu app no Meta for Developers.",
      "businessAccountId": "Business Account ID",
      "businessAccountIdPlaceholder": "Ex.: 987654321098765",
      "webhookVerifyToken": "Webhook Verify Token",
      "webhookVerifyTokenPlaceholder": "Token para verificação do webhook",
      "summary": "Resumo",
      "summaryMethod": "Método:",
      "summaryPhone": "Número:",
      "summaryBusiness": "Business Account ID:",
      "summaryToken": "Access Token:",
      "summaryWebhook": "Webhook Verify Token:",
      "validating": "Validando conexão…",
      "whatsappConnected": "WhatsApp conectado",
      "channelReadyInbox": "O canal já pode receber conversas no Inbox.",
      "cancel": "Cancelar",
      "finish": "Concluir",
      "continue": "Continuar",
      "close": "Fechar"
    },
    "whatsapp": {
      "connect": "Conectar WhatsApp",
      "connectAria": "Conectar WhatsApp",
      "howToGetPhoneNumberId": "Como obter phone_number_id",
      "howToGetPhoneNumberIdIntro": "O Pipeup atua como Tech Provider e precisa do phone_number_id do seu número no Meta for Developers.",
      "howToStep1": "Acesse Meta for Developers > seu app > WhatsApp > Configuração da API.",
      "howToStep2": "Em Números de telefone, copie o ID do número que deseja conectar.",
      "howToStep3": "Use o mesmo token com permissão whatsapp_business_messaging e whatsapp_business_management.",
      "emptyState": "O Pipeup atua como Tech Provider. Conecte o phone_number_id do seu número para receber e enviar mensagens no Inbox.",
      "manageNumbers": "Gerenciar números",
      "manage": "Gerenciar",
      "resolve": "Resolver",
      "footerLine": "Conecte seu número WhatsApp Cloud API.",
      "tokenError": "Erro na autenticação do token.",
      "numbersConnected": "{{count}} número(s) conectado(s)",
      "manageTitle": "Gerenciar números WhatsApp",
      "loadingAccounts": "Carregando números…",
      "noNumbers": "Nenhum número conectado.",
      "numberId": "Número",
      "test": "Testar",
      "copyPhoneNumberId": "Copiar Phone Number ID",
      "diagnostic": "Diagnóstico",
      "loadingDiagnostic": "Carregando…",
      "noDiagnostic": "Nenhum dado de diagnóstico disponível.",
      "tokenInvalid": "Token inválido ou sem permissão para este número.",
      "phoneNumberIdNotFound": "Phone Number ID não acessível com este token.",
      "validateError": "Erro ao validar a conexão. Verifique os dados e tente novamente."
    },
    "close": "Fechar",
    "confirmDesconectar": {
      "title": "Desconectar {{channelName}}?",
      "description": "As conversas existentes permanecem no Inbox. O canal deixará de receber novas mensagens até ser reconectado.",
      "disableWebchatTitle": "Desativar Webchat?",
      "disableWebchatDesc": "Ao desativar, o widget não aparecerá no site.",
      "disconnectLinkedInTitle": "Desconectar LinkedIn?",
      "disconnectLinkedInDesc": "Ao desconectar, você deixará de receber mensagens do LinkedIn na Inbox.",
      "confirmLabel": "Confirmar",
      "cancel": "Cancelar",
      "disconnect": "Desconectar",
      "waiting": "Aguarde…",
      "disconnecting": "Desconectando…"
    },
    "verSnippet": {
      "title": "Snippet do Webchat",
      "noSnippet": "(Nenhum snippet configurado)",
      "copy": "Copiar",
      "copied": "Copiado!",
      "close": "Fechar"
    },
    "adicionarDominio": {
      "title": "Adicionar domínio",
      "domainLabel": "Domínio",
      "domainPlaceholder": "ex: seudominio.com",
      "cancel": "Cancelar",
      "save": "Salvar"
    }
  }
}
